[
  {
    "key": "txtCbiCompetencyFrameworks",
    "text": "Competency Frameworks",
    "translations": [
      {
        "language": "AR",
        "text": "أطر الكفاءات"
      }
    ]
  },
  {
    "key": "txt_Exampleda_444",
    "text": "Example data shown for demonstration",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Leadershi_598",
    "text": "Leadership Circle Profile",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Clicktoex_185",
    "text": "Click to expand",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_360Leader_578",
    "text": "360 Leadership Index Survey",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Competenc_440",
    "text": "Competency:",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtLibrary",
    "text": "Library",
    "translations": [
      {
        "language": "AR",
        "text": "المكتبة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtEmailTemplates",
    "text": "Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "قوالب البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_update_from_file",
    "text": "Update from file",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_keep_from_pool",
    "text": "Keep from pool",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_set_all_to",
    "text": "Set all to: ",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_respondents_found_in_pool",
    "text": "{{0}} Respondents found in your pool",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_respondents_no_errors",
    "text": "<span class=\"font-medium\">{{0}}</span> Respondents detected without validation errors!",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_matched_with_existing",
    "text": "{{0}} Matched with existing",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_new_count",
    "text": "{{0}} New",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Pleasereu_180",
    "text": "Please reupload the file after you’ve fixed the validation errors mentioned above.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إعادة رفع الملف بعد إصلاح أخطاء التحقق المذكورة أعلاه."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "RespondentsValidationErorrs",
    "text": "<span>{{0}}</span> Respondents have the following validation errors:",
    "translations": [
      {
        "language": "AR",
        "text": "<span>{{0}}</span> يوجد لدى المستجيبين أخطاء التحقق التالية:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Click<spa_754",
    "text": "Click <span class=\"font-medium\">Next</span> to continue",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط <span class=\"font-medium\">التالي</span> للمتابعة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Respondentsdetected",
    "text": "<span class=\"font-medium\">{{0}}</span> Respondents detected!",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"font-medium\">{{0}}</span> تم العثور على مستجيبين!"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Uploading_993",
    "text": "Uploading in progress...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري رفع الملف..."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Abort_895",
    "text": "Abort",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Uploading_588",
    "text": "Uploading file...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري رفع الملف..."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Review&Fi_641",
    "text": "Review & Finalize",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DataValid_957",
    "text": "Data Validation",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_UploadDat_356",
    "text": "Upload Data",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_add_from_pool",
    "text": "Add from pool",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_matching_in_pool",
    "text": "Matching leaders in the pool",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_add_candidates",
    "text": "Add Candidates",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_add_manually",
    "text": "Add Manually",
    "translations": [
      {
        "language": "AR",
        "text": "إدخال بيانات المستجيب"
      },
      {
        "language": "FR",
        "text": "Ajouter Manuellement"
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Manually"
      }
    ]
  },
  {
    "key": "txt_candidates",
    "text": "candidates",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_no_candidates_desc",
    "text": "Saved candidates will appear here. Review your list before adding them to the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_no_candidates",
    "text": "No candidates",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_save_candidate",
    "text": "Save Candidate",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_basic_details",
    "text": "Basic details",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt360Index",
    "text": "360° Index",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_email_templates",
    "text": "Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "email_req",
    "text": "Email*",
    "translations": [
      {
        "language": "AR",
        "text": "*البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "name_req",
    "text": "Name*",
    "translations": [
      {
        "language": "AR",
        "text": "*اسم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Predefine_841",
    "text": "Predefined",
    "translations": [
      {
        "language": "AR",
        "text": "مُحدَّد مسبقًا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "TECHNICAL",
    "text": "TECHNICAL",
    "translations": [
      {
        "language": "AR",
        "text": "التقنية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DateSent_331",
    "text": "Date Sent",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإرسال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAiReadiness",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_row",
    "text": "Row",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAddCandidate_s",
    "text": "Add Candidate(s)",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přidat kandidáta (kandidáty)"
      },
      {
        "language": "EN",
        "text": "Add Candidate(s)"
      }
    ]
  },
  {
    "key": "txtFilters",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtRetryDownload",
    "text": "Retry Download",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_download_template",
    "text": "Download Template",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TocreateR_364",
    "text": "To create Respondent in bulk, download the premade spreadsheet template (.csv) file, and fill it with your data.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إضافة العديد من المست باستخدام جدول البيانات المُعرف مسبقاً (.csv) وهو يتضمن جميع المعلومات المطلوبة والتي يتطلب منك بتعبئتها."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Um Befragte als Paket zu erstellen, laden Sie die vorgefertigte Tabelle (.csv) herunter und füllen Sie sie mit Ihren Daten."
      },
      {
        "language": "PT",
        "text": "Para criar o Respondent em massa, baixe o arquivo de modelo de planilha predefinido (.csv) e preencha-o com seus dados."
      },
      {
        "language": "IT",
        "text": "Per creare rispondenti in blocco, scarica il template precompilato (.csv) e inserisci i tuoi dati."
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "EN",
        "text": "To create Respondent in bulk, download the premade spreadsheet template (.csv) file, and fill it with your data."
      }
    ]
  },
  {
    "key": "txt_res_pool",
    "text": "Respondent Pool",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSelectionDesc1",
    "text": "Select how you want to add respondents to this Live assessment:",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_status_closed",
    "text": "Closed",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_status_scheduled",
    "text": "Scheduled",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_status_draft",
    "text": "Draft",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_status_live",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TheProdcu_540",
    "text": "Your subscription has expired, to renew contact the Zenithr team",
    "translations": [
      {
        "language": "AR",
        "text": "انتهت صلاحية اشتراكك. للتجديد، يرجى التواصل مع فريق Zenithr."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectAll_997",
    "text": "Select All",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_UnselectA_631",
    "text": "Unselect All",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء التحديد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MultiLine",
    "text": "Open Text (Multi-line)",
    "translations": [
      {
        "language": "AR",
        "text": "نص مفتوح (متعدد الأسطر)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SingleLine",
    "text": "Open Text (Single-line)",
    "translations": [
      {
        "language": "AR",
        "text": "نص مفتوح (أحادي السطر)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Actionpla_407",
    "text": "Action plan edited successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تعديل خطة العمل بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "Status"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Status"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_created",
    "text": "Created",
    "translations": [
      {
        "language": "AR",
        "text": "Erstellt"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Erstellt"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_type",
    "text": "Type",
    "translations": [
      {
        "language": "AR",
        "text": "Typ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Typ"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_template",
    "text": "Template",
    "translations": [
      {
        "language": "AR",
        "text": "Vorlage"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtCulture",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم ثقافة وبيئة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "Search...",
    "text": "Search...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSend",
    "text": "Send",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": "Wyślij"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Schicken"
      },
      {
        "language": "ES",
        "text": "Enviar"
      },
      {
        "language": "PT",
        "text": "Enviar"
      },
      {
        "language": "EN",
        "text": "Send"
      },
      {
        "language": "IT",
        "text": "Invia"
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Technical_assessments",
    "text": "Technical Assessments",
    "translations": [
      {
        "language": "AR",
        "text": "التقييمات التقنية"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Benchmark_166",
    "text": "Benchmarking is available only for predefined drivers/factors at the company level.",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المعيارية متاحة للعوامل المحددة مسبقًا وعلى مستوى الشركة فقط."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Generated_922",
    "text": "Generated by Zenithr AI",
    "translations": [
      {
        "language": "AR",
        "text": "منشئ عن طريق حلول زينيثر المدعومة بالذكاء الاصطناعي"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Questions",
    "text": "Questions",
    "translations": [
      {
        "language": "AR",
        "text": "الأسئلة"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Tests",
    "text": "Tests",
    "translations": [
      {
        "language": "AR",
        "text": "الاختبارات"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_mins873",
    "text": "Mins",
    "translations": [
      {
        "language": "AR",
        "text": "دقيقة"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Impact_495",
    "text": "Impact",
    "translations": [
      {
        "language": "AR",
        "text": "مدى التأثير"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EditIniti_710",
    "text": "Edit Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المبادرة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Selectatl_642",
    "text": "Select at least one task for these focus areas: {{0}}",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى اختيار مهمة واحدة على الأقل من مجالات التركيز التالية: {{0}}"
      },
      {
        "language": "EN",
        "text": "Select at least one task for these focus areas: {{0}}"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Typetosea_606",
    "text": "Search Action Plans",
    "translations": [
      {
        "language": "AR",
        "text": "البحث عن خطة العمل"
      },
      {
        "language": "EN",
        "text": "Search Action Plans"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Notopicsa_385",
    "text": "No topics available!",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد مواضيع متاحة!"
      },
      {
        "language": "EN",
        "text": "No topics available!"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Selectatl_291",
    "text": "Select at least one task and assign owner for these focus areas: {{0}}",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى اختيار مهمة واحدة على الأقل وتعيين مسؤول لكل مجال من مجالات التركيز التالية: {{0}}"
      },
      {
        "language": "EN",
        "text": "Select at least one task and assign owner for these focus areas: {{0}}"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Selectatl_726",
    "text": "Select at least one initiative for these focus areas: {{0}}",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى اختيار مبادرة واحدة على الأقل من مجالات التركيز التالية: {{0}}"
      },
      {
        "language": "EN",
        "text": "Select at least one initiative for these focus areas: {{0}}"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Areyousur_119",
    "text": "Are you sure you want to close the action plan?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من رغبتك في إغلاق خطة العمل؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to close the action plan?"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectIni_201",
    "text": "Select Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المبادرات"
      },
      {
        "language": "EN",
        "text": "Select Initiatives"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectTas_953",
    "text": "Select Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المهام"
      },
      {
        "language": "EN",
        "text": "Select Tasks"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Summary_924",
    "text": "Summary",
    "translations": [
      {
        "language": "AR",
        "text": "ملخص"
      },
      {
        "language": "EN",
        "text": "Summary"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Details_566",
    "text": "Details",
    "translations": [
      {
        "language": "AR",
        "text": "التفاصيل"
      },
      {
        "language": "EN",
        "text": "Details"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FocusArea_988",
    "text": "Focus Areas Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas Overview"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Owner(s)_819",
    "text": "Owner(s)",
    "translations": [
      {
        "language": "AR",
        "text": "المسؤولين"
      },
      {
        "language": "EN",
        "text": "Owner(s)"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_648",
    "text": "Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة"
      },
      {
        "language": "EN",
        "text": "Initiative"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FocusArea_704",
    "text": "Focus Area",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Area"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EndDate_825",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      },
      {
        "language": "EN",
        "text": "End Date"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_StartDate_311",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      },
      {
        "language": "EN",
        "text": "Start Date"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Descripti_435",
    "text": "Description (Optional)",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف (اختياري)"
      },
      {
        "language": "EN",
        "text": "Description (Optional)"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Title_545",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "EN",
        "text": "Title"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Review&La_900",
    "text": "Review & Launch",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة وإطلاق"
      },
      {
        "language": "EN",
        "text": "Review & Launch"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Generatin_937",
    "text": "Generating Initiative...",
    "translations": [
      {
        "language": "AR",
        "text": "جارٍ إنشاء المبادرة..."
      },
      {
        "language": "EN",
        "text": "Generating Initiative..."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_select_atleast_one_task",
    "text": "Select at least one task for each focus area.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى اختيار مهمة واحدة على الأقل لكل مجال تركيز."
      },
      {
        "language": "EN",
        "text": "Select at least one task for each focus area."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_select_atleast_one_initiative",
    "text": "Select at least one initiative for each focus area.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى اختيار مبادرة واحدة على الأقل لكل مجال تركيز."
      },
      {
        "language": "EN",
        "text": "Select at least one initiative for each focus area."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectTas_565",
    "text": "Select Tasks <span class=\"font-normal text-zen-primaryLight\">({{0}})</span>",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المهام <span class=\"font-normal text-zen-primaryLight\">({{0}})</span>"
      },
      {
        "language": "EN",
        "text": "Select Tasks <span class=\"font-normal text-zen-primaryLight\">({{0}})</span>"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectIni_175",
    "text": "Select Initiatives <span class=\"font-normal text-zen-primaryLight\">({{0}})</span>",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المبادرات <span class=\"font-normal text-zen-primaryLight\">({{0}})</span>"
      },
      {
        "language": "EN",
        "text": "Select Initiatives <span class=\"font-normal text-zen-primaryLight\">({{0}})</span>"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_GenerateI_257",
    "text": "Generate Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مبادرة"
      },
      {
        "language": "EN",
        "text": "Generate Initiative"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AddInitia_968",
    "text": "Add Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مبادرة"
      },
      {
        "language": "EN",
        "text": "Add Initiative"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Driver",
    "text": "Driver",
    "translations": [
      {
        "language": "AR",
        "text": "العوامل "
      },
      {
        "language": "EN",
        "text": "Driver"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_duplicate_options_error",
    "text": "Duplicate Options",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات التكرار"
      },
      {
        "language": "EN",
        "text": "Duplicate Options"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Sentiment_685",
    "text": "Sentiment Analysis of Respondents’ Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل مشاعر تعليقات المستجيبين"
      },
      {
        "language": "EN",
        "text": "Sentiment Analysis of Respondents’ Comments"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Selectthe_523",
    "text": "Select the key engagement drivers and survey topics to prioritize in this action plan. These areas will be used to recommend relevant initiatives and action items in the next steps.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر أبرز عوامل الاندماج ومواضيع الاستبيان التي يجب إعطاؤها الأولوية في خطة العمل هذه. ستُستخدم هذه المجالات للتوصية بمبادرات وعناصر عمل ذات صلة في الخطوات التالية."
      },
      {
        "language": "EN",
        "text": "Select the key engagement drivers and survey topics to prioritize in this action plan. These areas will be used to recommend relevant initiatives and action items in the next steps."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Sentiment_877",
    "text": "Sentiments",
    "translations": [
      {
        "language": "AR",
        "text": "المشاعر"
      },
      {
        "language": "EN",
        "text": "Sentiments"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Score_640",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة"
      },
      {
        "language": "EN",
        "text": "Score"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "DRIVER / IMPACT",
    "translations": [
      {
        "language": "AR",
        "text": "عامل الاندماج الوظيفي"
      },
      {
        "language": "EN",
        "text": "DRIVER / IMPACT"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_topics_desc",
    "text": "➜ Topics identified from employee comments and sentiment analysis.",
    "translations": [
      {
        "language": "AR",
        "text": " المواضيع المستخلصة من تحليلات التعليقات وتحليل المشاعر."
      },
      {
        "language": "EN",
        "text": "➜ Topics identified from employee comments and sentiment analysis."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Topics_628",
    "text": "Topics",
    "translations": [
      {
        "language": "AR",
        "text": "الموضوعات"
      },
      {
        "language": "EN",
        "text": "Topics"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_driver_desc",
    "text": "➜ Lower Scores / High Impact indicate areas that may need improvement.",
    "translations": [
      {
        "language": "AR",
        "text": " الدرجات المنخفضة / التأثير العالي تشير إلى مجالات قد تحتاج إلى تحسين."
      },
      {
        "language": "EN",
        "text": "➜ Lower Scores / High Impact indicate areas that may need improvement."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "العوامل"
      },
      {
        "language": "EN",
        "text": "Drivers"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "FR",
        "text": "Retour"
      },
      {
        "language": "BN",
        "text": "পূর্ববর্তী"
      },
      {
        "language": "EN",
        "text": "Back"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectFoc_496",
    "text": "Select Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Select Focus Areas"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectEnt_745",
    "text": "Select Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select Entity"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_767",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Action Plan Details"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NewAction_220",
    "text": "New Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة عمل جديدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Action Plan"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "zen-select-placeholder",
    "text": "---Select---",
    "translations": [
      {
        "language": "AR",
        "text": "---اختيار ---"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "---Select---"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "email_exists",
    "text": "Email Already Exists",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني موجود بالفعل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Email Already Exists"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "duplicate_email",
    "text": "Duplicate email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني مكرر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Duplicate email"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "duplicate_employeeid",
    "text": "Duplicate employee id",
    "translations": [
      {
        "language": "AR",
        "text": "رقم هوية الموظف مكرر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Duplicate employee id"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "missing_name",
    "text": "Missing name",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Missing name"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "phone_invalid",
    "text": "Invalid phone number format",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة رقم الهاتف غير صالحة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invalid phone number format"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "email_invalid",
    "text": "Invalid email format",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة البريد الإلكتروني غير صالحة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invalid email format"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "missing_email",
    "text": "Missing email",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد بريد إلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Missing email"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "missing_employee_id",
    "text": "Missing employee id",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد رقم لهوية الموظف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Missing employee id"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "excel_file_empty",
    "text": "Excel file is Empty",
    "translations": [
      {
        "language": "AR",
        "text": "الملف فارغ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Excel file is Empty"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TotalPage_262",
    "text": "Total Pages",
    "translations": [
      {
        "language": "AR",
        "text": "عدد الصفحات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Total Pages"
      },
      {
        "language": "CS",
        "text": "Celkový počet stránek"
      }
    ]
  },
  {
    "key": "ap_reminder_unique",
    "text": "Invalid reminder date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ تذكير غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invalid reminder date"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Pleasesel_540",
    "text": "Please select initiatives.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى اختيار المبادرات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Please select initiatives."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Add/Selec_726",
    "text": "Add/Select Tasks for marked initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة/تحديد المهام للمبادرات المحددة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add/Select Tasks for marked initiatives"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Assignano_377",
    "text": "Assign an owner to marked initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول للمبادرات المحددة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Assign an owner to marked initiatives"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "at_row",
    "text": "at row",
    "translations": [
      {
        "language": "AR",
        "text": "في الصف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "at row"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "email_missing",
    "text": "email is missing",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "email is missing"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "name_missing",
    "text": "name is missing",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "name is missing"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_bulk_errors",
    "text": "Bulk Upload Errors",
    "translations": [
      {
        "language": "AR",
        "text": "أخطاء الرفع"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Bulk Upload Errors"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_n",
    "text": "n",
    "translations": [
      {
        "language": "AR",
        "text": "العدد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "n"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Duplicate email",
    "text": "Duplicate email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني مكرر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Duplicate email"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Duplicate employee id",
    "text": "Duplicate employee id",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهوية مكرر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Duplicate employee id"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Missing name",
    "text": "Missing name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Missing name"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Invalid phone number format",
    "text": "Invalid phone number format",
    "translations": [
      {
        "language": "AR",
        "text": "تنسيق رقم الهاتف غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invalid phone number format"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Invalid email format",
    "text": "Invalid email format",
    "translations": [
      {
        "language": "AR",
        "text": "تنسيق البريد إلكتروني غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invalid email format"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Missing email",
    "text": "Missing email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Missing email"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Missing employee id",
    "text": "Missing employee id",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهوية غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Missing employee id"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel file is empty or invalid",
    "text": "Excel file is empty or invalid",
    "translations": [
      {
        "language": "AR",
        "text": "ملف أكسل فارغ أو غير صالح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Excel file is empty or invalid"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Thisrepor_101",
    "text": "This report is computer generated. Zenithr accepts no liability for the consequences of the use of this report, however arising. The information contained within the report should be treated as confidential. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاء هذا التقرير بواسطة النظام تلقائيًا. لا تتحمل شركة زينيثر أي مسؤولية عن النتائج المترتبة على استخدام هذا التقرير، أياً كانت. يجب التعامل مع المعلومات الواردة في هذا التقرير على أنها سرية. "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "This report is computer generated. Zenithr accepts no liability for the consequences of the use of this report, however arising. The information contained within the report should be treated as confidential. "
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Company_715",
    "text": "Company",
    "translations": [
      {
        "language": "AR",
        "text": "الشركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Company"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_Based_on_res",
    "text": "(Based on {{0}}/{{1}}responses)",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى {{0}}/{{1}} من الردود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "(Based on {{0}}/{{1}}responses)"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FeedbackA_725",
    "text": "Feedback Avg. Rating",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط ​​تقييم التغذية الراجعة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback Avg. Rating"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Comments:_643",
    "text": "Comments:",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comments:"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_425",
    "text": "Initiative Expired",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة منتهية الصلاحية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiative Expired"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_202",
    "text": "Initiative Completed",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة مكتملة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiative Completed"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_863",
    "text": "Initiative In progress",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiative In progress"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FeedbackR_702",
    "text": "Feedback Ready",
    "translations": [
      {
        "language": "AR",
        "text": "التغذية الراجعة مكتملة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback Ready"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Feedbacki_459",
    "text": "Feedback in progress",
    "translations": [
      {
        "language": "AR",
        "text": "التغذية الراجعة قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback in progress"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_no_of_initiatives",
    "text": "({{0}} Initiatives)",
    "translations": [
      {
        "language": "AR",
        "text": "({{0}} المبادرات)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "({{0}} Initiatives)"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_no_initiatives",
    "text": "({{0}} Initiatives)",
    "translations": [
      {
        "language": "AR",
        "text": "({{0}} المبادرات)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "({{0}} Initiatives)"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comments"
      },
      {
        "language": "CS",
        "text": "Komentáře"
      }
    ]
  },
  {
    "key": "txt_Topic_383",
    "text": "Topic",
    "translations": [
      {
        "language": "AR",
        "text": "الموضوع"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Topic"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Bytopic_744",
    "text": "By topic",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الموضوع"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "By topic"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "IMP_LOW",
    "text": "Low Impact",
    "translations": [
      {
        "language": "AR",
        "text": "تأثير منخفض"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Low Impact"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_MediumImp_269",
    "text": "Medium Impact",
    "translations": [
      {
        "language": "AR",
        "text": "تأثير متوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Medium Impact"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Legend:_564",
    "text": "Legend:",
    "translations": [
      {
        "language": "AR",
        "text": "العلامة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Legend:"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Engagemen_465",
    "text": "Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Engagement Score"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_#ofInitia_853",
    "text": "# of Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المبادرات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "# of Initiatives"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ByDriver_187",
    "text": "By Driver",
    "translations": [
      {
        "language": "AR",
        "text": "حسب العامل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "By Driver"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FocusArea_339",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_OverallPr_554",
    "text": "Overall Progress",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الإنجاز الكلي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall Progress"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_684",
    "text": "Action Plan Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة لخطة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Action Plan Overview"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EnterUrlT_473",
    "text": "Enter Url Text",
    "translations": [
      {
        "language": "AR",
        "text": "أدخل نص عنوان URL"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Enter Url Text"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EnterUrl_552",
    "text": "Enter Url",
    "translations": [
      {
        "language": "AR",
        "text": "أدخل عنوان URL"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Enter Url"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ImageUrl_807",
    "text": "Image Url",
    "translations": [
      {
        "language": "AR",
        "text": "رابط الصورة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Image Url"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DownloadC_152",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download Comments"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_487",
    "text": "Action Plan not found!",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على خطة عمل!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Action Plan not found!"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_(Overdueb_788",
    "text": "(Overdue by {{0}} days)",
    "translations": [
      {
        "language": "AR",
        "text": "(منتهية من {{0}} يومًا)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "(Overdue by {{0}} days)"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_CompareEntities",
    "text": "Compare Entities",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الوحدات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Compare Entities"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Compariso_762",
    "text": "Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comparison Report"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Comparesu_471",
    "text": "Compare Superiors",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة المدراء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Compare Superiors"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Engagemen_620",
    "text": "Engagement Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Engagement Comparison"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Resetting_293",
    "text": "Resetting the end date will reset the due dates of all initiatives.",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة ضبط تاريخ الانتهاء سيؤدي إلى إعادة ضبط تواريخ الإكمال لجميع المبادرات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Resetting the end date will reset the due dates of all initiatives."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "CustomCriteria",
    "text": "Custom Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Custom Criteria"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "PositionalInformation",
    "text": "Positional Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الوظيفية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Positional Information"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "PersonalInformation",
    "text": "Personal Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الشخصية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Personal Information"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Edit_337",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Edit"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_598",
    "text": "Initiatives not found!",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على مبادرات!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiatives not found!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtOwners",
    "text": "Owner Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "لوحة قيادة المسؤول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Owner Dashboard"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Owners_338",
    "text": "Owners",
    "translations": [
      {
        "language": "AR",
        "text": "المسؤولون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Owners"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Howeffect_404",
    "text": "How effective was this initiative for you?",
    "translations": [
      {
        "language": "AR",
        "text": "ما مدى فعالية هذه المبادرة بالنسبة لك؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "How effective was this initiative for you?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AutoSaved_568",
    "text": "Auto Saved",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحفظ تلقائياً"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Auto Saved"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Saving..._587",
    "text": "Saving...",
    "translations": [
      {
        "language": "AR",
        "text": "جارٍ الحفظ..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Saving..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_PositiveC_732",
    "text": "Positive Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات الإيجابية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Positive Comments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NeutralCo_314",
    "text": "Neutral Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات المحايدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Neutral Comments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NegativeC_395",
    "text": "Negative Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات السلبية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Negative Comments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_POS_ResponseRate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Response Rate"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_minimum3",
    "text": "Please add minimum 3 respondents to continue!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة 3 مستجيبين كحد أدنى للمتابعة!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Please add minimum 3 respondents to continue!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TeamOvera_477",
    "text": "Team Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية للفريق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Team Overall Score"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "IMP_MID",
    "text": "Mid Impact",
    "translations": [
      {
        "language": "AR",
        "text": "تأثير متوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Mid Impact"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "IMP_HIGH",
    "text": "High Impact",
    "translations": [
      {
        "language": "AR",
        "text": "تأثير مرتفع"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "High Impact"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ManageTas_997",
    "text": "Manage Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Manage Tasks"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TasksSele_964",
    "text": "Tasks Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المختارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Tasks Selected"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "HR Metrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "HR Metrics"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Demographics",
    "text": "Demographics",
    "translations": [
      {
        "language": "AR",
        "text": "الديموغرافية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Demographics"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ExtraCriteria",
    "text": "Extra Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Extra Criteria"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "BusinessLevel",
    "text": "Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Business Level"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_POS_EnpsScore",
    "text": "Team eNPS Score",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين للفريق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Team eNPS Score"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_EnpsScore",
    "text": "eNPS Score",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "eNPS Score"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "TotalCompleted",
    "text": "Number of Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Number of Respondents"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_Conf",
    "text": "Results require at least 3 respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "النتائج تتطلب ما لا يقل عن 3 مستجيبين."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Results require at least 3 respondents."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CenterOrg_992",
    "text": "Center Org Chart",
    "translations": [
      {
        "language": "AR",
        "text": "تركيز الهيكل التنظيمي في المنتصف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Center Org Chart"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Minimized_914",
    "text": "Minimize",
    "translations": [
      {
        "language": "AR",
        "text": "تصغير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Minimize"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Fullscree_109",
    "text": "Fullscreen",
    "translations": [
      {
        "language": "AR",
        "text": "شاشة كاملة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Fullscreen"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_YourIniti_874",
    "text": "Your Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات الخاص بك"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your Initiatives"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_OwnerDash_551",
    "text": "Owner Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "لوحة قيادة المسؤول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Owner Dashboard"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_182",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiatives"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Tasks_771",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Tasks"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_429",
    "text": "Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Action Plan"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BacktoDas_820",
    "text": "Back to Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "العودة إلى لوحة قيادة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Back to Dashboard"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Timeframe_732",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Timeframe"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Usercreat_899",
    "text": "User created Tests",
    "translations": [
      {
        "language": "AR",
        "text": "الاختبارات التي أنشأها المستخدم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "User created Tests"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_184",
    "text": "Initiatives:",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiatives:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Reports_144",
    "text": "Reports",
    "translations": [
      {
        "language": "AR",
        "text": "التقارير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reports"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_367",
    "text": "Action Plans",
    "translations": [
      {
        "language": "AR",
        "text": "خطط العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Action Plans"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Welcome_935",
    "text": "Welcome,",
    "translations": [
      {
        "language": "AR",
        "text": "أهلاً وسهلاً"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Welcome,"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_assign_initative_owner",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعيين مسؤول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Assign Owner"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_Compare",
    "text": "Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Compare"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_P2PCOMP",
    "text": "P2P Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة زميل لزميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "P2P Compare"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ViewActio_299",
    "text": "View Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "عرض خطة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "View Action Plan"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Youriniti_836",
    "text": "Your initiatives are now live and visible to all assigned owners. You can monitor progress from the dashboard at any time.<br><br>Let’s make an impact.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إطلاق المبادرات الخاص بك حيث أصبحت مرئية لجميع المسؤولين المحددين. يمكنك متابعة الحالة من لوحة القيادة في أي وقت."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your initiatives are now live and visible to all assigned owners. You can monitor progress from the dashboard at any time.<br><br>Let’s make an impact."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_878",
    "text": "Action Plan Launched Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إطلاق خطة العمل بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Action Plan Launched Successfully!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Yourselec_392",
    "text": "Your selected initiatives are now set. Once launched, they’ll be visible to all assigned owners forexecution.<br> <br>Are you sure you want to proceed?",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المختارة الخاص بك أصبحت جاهزة الآن. بمجرد إطلاقها، ستكون مرئية لجميع المسؤولين المخصصين لـ التنفيذ.<br> <br>هل أنت متأكد أنك تريد المتابعة؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your selected initiatives are now set. Once launched, they’ll be visible to all assigned owners forexecution.<br> <br>Are you sure you want to proceed?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_LaunchNow_156",
    "text": "Launch Now",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق الآن"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Launch Now"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ReadytoLa_509",
    "text": "Ready to Launch Your Action Plan?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد لإطلاق خطة العمل الخاصة بك؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "هل أنت مستعد لإطلاق خطة العمل الخاصة+C57 بك؟"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "All"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Stars_270",
    "text": "Stars",
    "translations": [
      {
        "language": "AR",
        "text": "النجوم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Stars"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Basedon01",
    "text": "Based on {{0}}/{{1}} responses",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى {{0}}/{{1}} من الردود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Based on {{0}}/{{1}} responses"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Basedon{{_395",
    "text": "Based on {{0}}/{{1}} responses",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى {{0}}/{{1}} من الردود"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Based on {{0}}/{{1}} responses"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Avg.Ratin_915",
    "text": "Avg. Rating",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Avg. Rating"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Q"
      },
      {
        "language": "IT",
        "text": "Q"
      },
      {
        "language": "CS",
        "text": "Q"
      }
    ]
  },
  {
    "key": "txt_FeedbackC_775",
    "text": "Feedback Completed",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال الملاحظات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback Completed"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Closethis_489",
    "text": "Close this window",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق النافذة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Close this window"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Weappreci_270",
    "text": "We appreciate your time and valuable insights,they help us make future initiatives even more impactful.",
    "translations": [
      {
        "language": "AR",
        "text": "نحن نقدر وقتك وملاحظاتك القيمة، فهي تساعدنا في جعل المبادرات المستقبلية أكثر تأثيرًا على مكان العمل."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "We appreciate your time and valuable insights,they help us make future initiatives even more impactful."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_VeryEffec_702",
    "text": "Very Effective",
    "translations": [
      {
        "language": "AR",
        "text": "فعال جداً"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Very Effective"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NotEffect_730",
    "text": "Not Effective",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Not Effective"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FeedbackS_835",
    "text": "Feedback Survey Closed Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال الاستبيان بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback Survey Closed Successfully!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Yourrespo_418",
    "text": "Your response has been recorded successfully. <br> We appreciate your time and valuable insights they help us make future initiatives even more impactful.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال الاستبيان بنجاح! <br> نحن نقدر وقتك وملاحظاتك القيمة، فهي تساعدنا في جعل المبادرات المستقبلية أكثر تأثيرًا على مكان العمل."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your response has been recorded successfully. <br> We appreciate your time and valuable insights they help us make future initiatives even more impactful."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_FeedbackS_542",
    "text": "Feedback Submitted Successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال الاستبيان بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback Submitted Successfully"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SubmitYou_315",
    "text": "Submit Your Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقديم الاستبيان"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Submit Your Feedback"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Shareyour_483",
    "text": "Share your thoughts here",
    "translations": [
      {
        "language": "AR",
        "text": "شارك أفكارك الخاصة بك هنا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Share your thoughts here"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Comment(o_108",
    "text": "Comment (optional)",
    "translations": [
      {
        "language": "AR",
        "text": "تعليق (اختياري)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comment (optional)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_StrongImp_717",
    "text": "Strong Impact",
    "translations": [
      {
        "language": "AR",
        "text": "تأثير مرتفع"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Strong Impact"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_WeakImpac_959",
    "text": "Weak Impact",
    "translations": [
      {
        "language": "AR",
        "text": "تأثير منخفض"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Weak Impact"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Selectano_844",
    "text": "Select an option:",
    "translations": [
      {
        "language": "AR",
        "text": "اختر خيارًا:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select an option:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Towhatext_468",
    "text": "To what extent do you feel this initiative had a positive impact on your experience at work?",
    "translations": [
      {
        "language": "AR",
        "text": "إلى أي مدى تشعر أن هذه المبادرة كان لها تأثير إيجابي على تجربتك في العمل؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "To what extent do you feel this initiative had a positive impact on your experience at work?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtContinue",
    "text": "Continue",
    "translations": [
      {
        "language": "AR",
        "text": "استمر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Continue"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Thissurve_224",
    "text": "This survey is anonymous and will take less than a minute.",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الاستبيان مجهول الهوية ولن يستغرق أكثر من دقيقة واحدة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "This survey is anonymous and will take less than a minute."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "passwordsDoNotMatch",
    "text": "Passwords do not match.",
    "translations": [
      {
        "language": "AR",
        "text": "كلمات المرور غير متطابقة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Passwords do not match."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "invalid_reset_token",
    "text": "invalid password ",
    "translations": [
      {
        "language": "AR",
        "text": "كلمة المرور غير صحيحة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "invalid password "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Products_953",
    "text": "Products",
    "translations": [
      {
        "language": "AR",
        "text": "الحلول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Products"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_LastPurch_385",
    "text": "Last Purchased Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الشراء الأخير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Last Purchased Date"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_465",
    "text": "Initiative Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على المبادرة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Initiative Overview"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_YourInput_909",
    "text": "Your Input help us understand how effective this initiative has been and what could be improved for future actions.",
    "translations": [
      {
        "language": "AR",
        "text": "المُدخلات الخاصة بك تساعدنا على فهم مدى فاعلية هذه المبادرة وما يمكن تحسينه لـ الإجراءات المستقبلية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your Input help us understand how effective this initiative has been and what could be improved for future actions."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_We’dlovey_825",
    "text": "We’d love your feedback",
    "translations": [
      {
        "language": "AR",
        "text": "نود معرفة رأيك الخاص بك"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "We’d love your feedback"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "reset",
    "text": "reset",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة ضبط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "reset"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CloseNow_502",
    "text": "Close Now",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Close Now"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Areyousur_242",
    "text": "Are you sure you want to close the feedback survey?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من رغبتك في إغلاق الاستبيان؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Are you sure you want to close the feedback survey early?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CloseFeed_525",
    "text": "Close Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق الاستبيان"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Close Feedback"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Reminders_767",
    "text": "Reminders sent Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال التذكيرات بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reminders sent Successfully!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_InProgres_394",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In Progress"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Status_456",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Status"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Show_724",
    "text": "Show",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Show"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SendRemin_783",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال تذكير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Send Reminder"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Searchfor_384",
    "text": "Search for respondents...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن المستجيبون..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Search for respondents..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_({{0}}of{_373",
    "text": "({{0}} of {{1}} Responded)",
    "translations": [
      {
        "language": "AR",
        "text": "(استجاب {{0}} من {{1}} )"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "({{0}} of {{1}} Responded)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Feedbacki_744",
    "text": "Feedback in progress...",
    "translations": [
      {
        "language": "AR",
        "text": "الاستبيان قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Feedback in progress..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ViewResul_227",
    "text": "View Results",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "View Results"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_LiveAnaly_187",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات المباشرة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Live Analytics"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Dismiss_367",
    "text": "Dismiss",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Dismiss"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SurveySen_770",
    "text": "Survey Sent Successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال الاستبيان بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Sent Successfully"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ForInitia_209",
    "text": "For Initiative:",
    "translations": [
      {
        "language": "AR",
        "text": "لـ المبادرة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "For Initiative:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SendNow_148",
    "text": "Send Now",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الآن"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Send Now"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Messagebo_348",
    "text": "Message body",
    "translations": [
      {
        "language": "AR",
        "text": "نص الرسالة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Message body"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ReminderT_344",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reminder Template"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Invitatio_286",
    "text": "Invitation Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الدعوة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invitation Template"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ReuploadT_260",
    "text": "Reupload Template",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة رفع النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reupload Template"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Validatio_245",
    "text": "Validation Error at Row #{{0}}, ",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ التحقق في الصف رقم #{{0}},"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Validation Error at Row #{{0}}, "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Retry_269",
    "text": "Retry",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة المحاولة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Retry"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AddRespon_838",
    "text": "Add Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Respondents"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Typetosea_872",
    "text": "Type to search...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب للبحث..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Type to search..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "send_using_whatsapp",
    "text": "Send Invites By WhatsApp",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات عبر الواتساب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Send Invites By WhatsApp"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "send_using_whatsapp_desc",
    "text": "Send Invites Using WhatsApp",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات عبر الواتساب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Send Invites Using WhatsApp"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Bydeselec_913",
    "text": "By deselecting Line Manager from the analysis criteria, the Positional Chart will be disabled from the results. Do you want to continue?",
    "translations": [
      {
        "language": "AR",
        "text": "يعتمد المخطط الوظيفي على بيانات المدير المباشر. يرجى اختيار هذا المعيار فقط إذا كانت بيانات المدير المباشر متوفرة للمستجيبين. إذا قمت بإلغاء تحديده، فسيتم تعطيل الهيكل الوظيفي من التحليلات."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The Positional Chart depends on Line Manager data. Please select this criterion only if direct manager information is available for your respondents. If you deselect it, the Positional Chart will be disabled from the analysis."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Confirm_322",
    "text": "Confirm",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Confirm"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DeselectC_979",
    "text": "Deselect Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد إلغاء التحديد"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Deselect Confirmation"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_LoginHere_266",
    "text": "Login Here",
    "translations": [
      {
        "language": "AR",
        "text": "سجّل الدخول هنا"
      },
      {
        "language": "DE",
        "text": "Hier anmelden"
      },
      {
        "language": "EN",
        "text": "Login Here"
      },
      {
        "language": "IT",
        "text": "Accedi qui"
      },
      {
        "language": "CS",
        "text": "Přihlaste se zde"
      }
    ]
  },
  {
    "key": "txt_InvalidLi_593",
    "text": "Invalid Link",
    "translations": [
      {
        "language": "AR",
        "text": "رابط غير صالح"
      },
      {
        "language": "DE",
        "text": "Ungültiger Link"
      },
      {
        "language": "EN",
        "text": "Invalid Link"
      },
      {
        "language": "IT",
        "text": "Link non valido"
      },
      {
        "language": "CS",
        "text": "Neplatný odkaz"
      }
    ]
  },
  {
    "key": "txt_directManager_name",
    "text": "Direct Manager",
    "translations": [
      {
        "language": "AR",
        "text": "المدير المباشر"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Direct Manager"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_directManager_ID",
    "text": "Direct Manager ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي للمدير المباشر"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Direct Manager ID"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      },
      {
        "language": "DE",
        "text": "Breakout"
      },
      {
        "language": "EN",
        "text": "Breakout:"
      },
      {
        "language": "IT",
        "text": "Suddivisione:"
      },
      {
        "language": "CS",
        "text": "Průnik:"
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comparison: Overall"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Median"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Low"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "High"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Heatmap"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The value displayed in the cell is delta, which represents a difference in the overall value."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download Heatmap"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Preparing Heatmap"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "topPerformer",
    "text": "Top Performer (MENA)",
    "translations": [
      {
        "language": "AR",
        "text": "الأفضل أداء (منطقة الشرق الأوسط وشمال أفريقيا)"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Top Performer (MENA)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "mena",
    "text": "MENA Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط منطقة الشرق الأوسط وشمال أفريقيا"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "MENA Avg."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "previous",
    "text": "Previous Survey",
    "translations": [
      {
        "language": "AR",
        "text": "الاستبيان السابق"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Previous Survey"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtBenchmarkLegend",
    "text": "Benchmark Legend",
    "translations": [
      {
        "language": "AR",
        "text": "نوع المعيار"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Benchmark Legend"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "industry",
    "text": "Industry",
    "translations": [
      {
        "language": "AR",
        "text": "القطاع الصناعي"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Industry"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "country",
    "text": "Country",
    "translations": [
      {
        "language": "AR",
        "text": "الدولة"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Country"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Segments",
    "text": "Segments",
    "translations": [
      {
        "language": "AR",
        "text": "قطاعات أخرى"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Segments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Top Performers",
    "text": "Top Performers",
    "translations": [
      {
        "language": "AR",
        "text": "أفضل أداء"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Top Performers"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtGlobal",
    "text": "MENA",
    "translations": [
      {
        "language": "AR",
        "text": "الشرق الأوسط"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "MENA"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtPrevious",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Previous"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "general",
    "text": "General",
    "translations": [
      {
        "language": "AR",
        "text": "العام"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "General"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "ApplyBenchmark",
    "text": "Apply Benchmark",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Apply Benchmark"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtBenchmarks",
    "text": "Benchmarks",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Benchmarks"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ResetTemp_946",
    "text": "Reset Template",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage zurücksetzen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reset Template"
      },
      {
        "language": "IT",
        "text": "Reimposta il template"
      },
      {
        "language": "CS",
        "text": "Resetovat šablonu"
      }
    ]
  },
  {
    "key": "txtChooseLanguage",
    "text": "Choose Language",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار اللغة"
      },
      {
        "language": "DE",
        "text": "Sprache wählen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Choose Language"
      },
      {
        "language": "IT",
        "text": "Scegli la lingua"
      },
      {
        "language": "CS",
        "text": "Vyberte jazyk"
      }
    ]
  },
  {
    "key": "txt_id",
    "text": "ID:",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي:"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "ID:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Create_850",
    "text": "Create",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Create"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_edit_respondents",
    "text": "Edit Respondent(s)",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المستجيب"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Edit Respondent(s)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_select_respondent",
    "text": "Select how you want to add respondents:",
    "translations": [
      {
        "language": "AR",
        "text": "حدد الطريقة التي تريد بها إضافة المستجيبين:"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select how you want to add respondents:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_bulk_upload",
    "text": "Bulk Upload",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل دفعة واحدة"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Bulk Upload"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_new_respondents",
    "text": "New Respondent(s)",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيب جديد"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Respondent(s)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_error_create",
    "text": "Error creating respondent",
    "translations": [
      {
        "language": "AR",
        "text": "حصل خطأ في إنشاء المستجيب"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Error creating respondent"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_success_new_respondent",
    "text": "New respondent has been created successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاء المستجيب الجديد بنجاح!"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New respondent has been created successfully!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_business_level",
    "text": "Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى الأعمال"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Business Level"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Table_Columns",
    "text": "Table Columns",
    "translations": [
      {
        "language": "AR",
        "text": "أعمدة الجدول"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Table Columns"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_delete_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا المستجيب؟"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this respondent?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "select",
    "text": "- Select -",
    "translations": [
      {
        "language": "AR",
        "text": "- اختيار -"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "- Select -"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "CopyPassword",
    "text": "Copy Password",
    "translations": [
      {
        "language": "AR",
        "text": "نسخ كلمة المرور"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Copy Password"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "GeneratePassword",
    "text": "Generate Password",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء كلمة مرور"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Generate Password"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtBy",
    "text": "by",
    "translations": [
      {
        "language": "AR",
        "text": "حسب"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "by"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "enpsScore",
    "text": "eNPS Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة صافي نقاط ترويج الموظفين"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "eNPS Score"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "eNPS skóre"
      }
    ]
  },
  {
    "key": "AppliedFilters",
    "text": "Applied Filters",
    "translations": [
      {
        "language": "AR",
        "text": "التصفيات المطبقة"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Applied Filters"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate\t",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      },
      {
        "language": "DE",
        "text": "Antwortrate"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Response Rate\t"
      },
      {
        "language": "IT",
        "text": "Tasso di risposta"
      },
      {
        "language": "CS",
        "text": "Míra odezvy"
      }
    ]
  },
  {
    "key": "rateRespondentsDesc",
    "text": "The rate of respondents who completed the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "نسبة المستجيبين الذين استكملوا الاستبيان."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Die Rate der Befragten, die die Umfrage abgeschlossen haben."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The rate of respondents who completed the survey."
      },
      {
        "language": "IT",
        "text": "Il tasso di rispondenti che ha completato la survey."
      },
      {
        "language": "CS",
        "text": "Procento respondentů, kteří dotazník vyplnili."
      }
    ]
  },
  {
    "key": "txt_ChartType_397",
    "text": "Chart Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Chart Type"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "gena_years",
    "text": "Born after 2011",
    "translations": [
      {
        "language": "AR",
        "text": "ولد بعد سنة 2011"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Born after 2011"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "genz_years",
    "text": "Born 1996 - 2011",
    "translations": [
      {
        "language": "AR",
        "text": "مواليد 1996 - 2011"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Born 1996 - 2011"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "geny_years",
    "text": "Born 1981 - 1996",
    "translations": [
      {
        "language": "AR",
        "text": "مواليد 1981 - 1996"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Born 1981 - 1996"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "genx_years",
    "text": "Born 1961 - 1981",
    "translations": [
      {
        "language": "AR",
        "text": "مواليد 1961 - 1981"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Born 1961 - 1981"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "babyboomers_years",
    "text": "Born 1946 - 1961",
    "translations": [
      {
        "language": "AR",
        "text": "مواليد 1946 - 1961"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Born 1946 - 1961"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "maturists_years",
    "text": "Born before 1946",
    "translations": [
      {
        "language": "AR",
        "text": "ولد قبل سنة 1946"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Born before 1946"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_disabe2fa",
    "text": "Disable 2FA",
    "translations": [
      {
        "language": "AR",
        "text": "تعطيل 2FA"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Disable 2FA"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_enable2fa",
    "text": "Enable 2FA",
    "translations": [
      {
        "language": "AR",
        "text": "تفعيل التحقق بخطوتين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Enable 2FA"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Responden_395",
    "text": "Respondents Sharing",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة المستجيبون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents Sharing"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "secure_landing",
    "text": "Highly Secured",
    "translations": [
      {
        "language": "AR",
        "text": "آمن للغاية"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Highly Secured"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "secure_landing_desc",
    "text": "Disable email invitations and verify respondents' access to the survey using their unique ID and email address.",
    "translations": [
      {
        "language": "AR",
        "text": "تعطيل دعوات الاستبيان عن طريق البريد الإلكتروني والتحقق من دخول المستجيبين إلى الاستبيان باستخدام رقم الهوية والبريد الإلكتروني الخاص بهم."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Disable email invitations and verify respondents' access to the survey using their unique ID and email address."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUsername",
    "text": "Username",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المستخدم"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Username"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "AccessDenied",
    "text": "Access Denied",
    "translations": [
      {
        "language": "AR",
        "text": "تم رفض الوصول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Access Denied"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "secureLandingFailureText",
    "text": "Please refer to your organization's admin to verify your credentials.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى التواصل مع مسؤول النظام للشركة للتحقق من بياناتك."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Please refer to your organization's admin to verify your credentials."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Top10_977",
    "text": "Top 10",
    "translations": [
      {
        "language": "AR",
        "text": "أعلى 10"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Top 10"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "female",
    "text": "Female",
    "translations": [
      {
        "language": "AR",
        "text": "انثى"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Female"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "male",
    "text": "Male",
    "translations": [
      {
        "language": "AR",
        "text": "ذكر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Male"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Responden_481",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondent Analysis"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Analýza respondentů"
      }
    ]
  },
  {
    "key": "txt_gotoDashboard",
    "text": "Go to Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "الذهاب إلى لوحة القيادة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Go to Dashboard"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtNoDataAvailable",
    "text": "No Data Available",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد بيانات متاحة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Keine Daten verfügbar"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "No Data Available"
      },
      {
        "language": "IT",
        "text": "Nessun dato disponibile"
      },
      {
        "language": "CS",
        "text": "Nejsou k dispozici žádné údaje"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Responses",
    "translations": [
      {
        "language": "AR",
        "text": "الردود"
      },
      {
        "language": "FR",
        "text": "Réponses"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Responses"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "RespondentsBy",
    "text": "Respondents by",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      },
      {
        "language": "DE",
        "text": "Befragte von"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents by"
      },
      {
        "language": "IT",
        "text": "Rispondenti in base a"
      },
      {
        "language": "CS",
        "text": "Respondenti podle"
      }
    ]
  },
  {
    "key": "enpsScoreByCriteria",
    "text": "eNPS Score By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين حسب المعايير"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Enps Score By Criteria"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Breakout",
    "text": "Breakout",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Breakout"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "přestávka"
      }
    ]
  },
  {
    "key": "ScoreByCriteria",
    "text": "Score By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة حسب المعايير"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Score By Criteria"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "hodnocení podle kritérií"
      }
    ]
  },
  {
    "key": "Passives",
    "text": "Passives",
    "translations": [
      {
        "language": "AR",
        "text": "السلبيون"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Passives"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "neutrální"
      }
    ]
  },
  {
    "key": "Detractors",
    "text": "Detractors",
    "translations": [
      {
        "language": "AR",
        "text": "المنتقدون"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Detractors"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "kritici"
      }
    ]
  },
  {
    "key": "Promoters",
    "text": "Promoters",
    "translations": [
      {
        "language": "AR",
        "text": "المروجون"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Promoters"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "propagátoři"
      }
    ]
  },
  {
    "key": "txtZenithrElevate",
    "text": "Zenithr Elevate",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Zenithr Elevate"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurveyCloningSuccess",
    "text": "Survey has been cloned successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم استنساخ الاستبيان بنجاح!"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey has been cloned successfully!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Clone",
    "text": "Clone",
    "translations": [
      {
        "language": "AR",
        "text": "استنساخ"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Clone"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "cloned",
    "text": "cloned",
    "translations": [
      {
        "language": "AR",
        "text": "تم الاستنساخ"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "cloned"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ViewAnaly_900",
    "text": "View Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التحليلات"
      },
      {
        "language": "DE",
        "text": "Analyse anzeigen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "View Analysis"
      },
      {
        "language": "IT",
        "text": "Visualizza l'analisi"
      },
      {
        "language": "CS",
        "text": "Zobrazit analýzu"
      }
    ]
  },
  {
    "key": "txt_Responden_582",
    "text": "Respondents filtered by",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل المستجيبون حسب"
      },
      {
        "language": "DE",
        "text": "Befragte gefiltert nach"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents filtered by"
      },
      {
        "language": "IT",
        "text": "Rispondenti filtrati per"
      },
      {
        "language": "CS",
        "text": "Respondenti filtrovaní podle"
      }
    ]
  },
  {
    "key": "txt_Export_229",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "DE",
        "text": "Export"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Export"
      },
      {
        "language": "IT",
        "text": "Esporta "
      },
      {
        "language": "CS",
        "text": "Exportovat"
      }
    ]
  },
  {
    "key": "txt_RawData_453",
    "text": "Raw Data",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل البيانات"
      },
      {
        "language": "DE",
        "text": "Rohdaten"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Raw Data"
      },
      {
        "language": "IT",
        "text": "Dati grezzi"
      },
      {
        "language": "CS",
        "text": "Nezpracovaná data"
      }
    ]
  },
  {
    "key": "txtGotit",
    "text": "Got it",
    "translations": [
      {
        "language": "AR",
        "text": "تمّ."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Got it"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "announcement1Desc",
    "text": "Discover our new vibrant colors in our latest update.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف ألواننا الحيوية الجديدة في أحدث تحديث لدينا."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Discover our new vibrant colors in our latest update."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "announcement1Text",
    "text": "Your experience just got more colorful!",
    "translations": [
      {
        "language": "AR",
        "text": "تجربتك أصبحت أكثر حيوية!"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your experience just got more colorful!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSingleSectioinForDemo",
    "text": "You are permitted to select only one optional driver!",
    "translations": [
      {
        "language": "AR",
        "text": "يُسمح لك باختيار عامل اختياري واحد فقط!"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "You are permitted to select only one optional driver!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAnalysis_exit",
    "text": "On the <b>“Analysis”</b> page, you uncover the overall results for leavers who completed the survey!\t",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"التحليلات\"</b> تكشف الدرجات الكلية لجميع المغادرين الذين استكملوا الاستبيان!"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "On the <b>“Analysis”</b> page, you uncover the overall results for leavers who completed the survey!\t"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtTemplate_exit",
    "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs!\t",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"نماذج الاستبيان\" </b>يمكنك عرض أسئلة النماذج المُعرفة مسبقاُ وإنشاء نماذج جديدة مصممة خصيصاً لتلبية احتياجاتك!"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs!\t"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_leavers_exit",
    "text": "On the <b>“Leavers”</b> page, you add the leavers and track their survey status, send reminders, and view each leaver’s answer individually.\t",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"الموظفين المغادرين\"</b> تقوم بإضافة الموظفين الذين غادروا مكان العمل وتتبع حالة الاستبيان وإرسال تذكيرات وعرض أجوبة كل موظف مغادر على حدة."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "On the <b>“Leavers”</b> page, you add the leavers and track their survey status, send reminders, and view each leaver’s answer individually.\t"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Clickonth_446",
    "text": "Click on the bar to filter each dimension’s/statement’s comments by sentiment type.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على الشريط لعرض تعليقات كل بُعد/عبارة حسب نوع المشاعر والآراء."
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click on the bar to filter each dimension’s/statement’s comments by sentiment type."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kliknutím na pruh můžete filtrovat komentáře ke každé dimenzi/výroku podle typu emocí."
      }
    ]
  },
  {
    "key": "txt_Clickonth_957",
    "text": "Click on the bar to filter each factor’s/statement’s comments by sentiment type. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على الشريط لعرض تعليقات كل عامل سعادة/عبارة حسب نوع المشاعر والآراء. "
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click on the bar to filter each factor’s/statement’s comments by sentiment type. "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kliknutím na pruh můžete filtrovat komentáře ke každému faktoru či tvrzení podle typu emocí"
      }
    ]
  },
  {
    "key": "txtComparison_happiness",
    "text": "Ready to uncover your survey history's top happiness scores and compare them across years and companies (if any)? Discover the answer now! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج السعادة للموظف ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن! "
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Ready to uncover your survey history's top happiness scores and compare them across years and companies (if any)? Discover the answer now! "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAnalytics_onBoarding",
    "text": "On the <b>“Analysis”</b> page, you uncover the overall results for joiners who completed the survey! ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"التحليلات\"</b> تكشف الدرجات الكلية لجميع الموظفين الجدد الذين استكملوا الاستبيان! "
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "On the <b>“Analysis”</b> page, you uncover the overall results for joiners who completed the survey! "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtTemplate_onBoarding",
    "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs! ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"نماذج الاستبيان\"</b> يمكنك عرض أسئلة النماذج المُعرفة مسبقاُ وإنشاء نماذج جديدة مصممة خصيصاً لتلبية احتياجاتك! "
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs! "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtList_onBoarding",
    "text": "On the <b>“Joiners List”</b> page, you add the new joiners, track their survey status, send reminders, and view each joiner’s answer individually. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\" قائمة الموظفين الجدد \"</b> تقوم بإضافة الموظفين الجدد وتتبع حالة الاستبيان وإرسال تذكيرات وعرض أجوبة كل موظف جديد على حدة. "
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "On the <b>“Joiners List”</b> page, you add the new joiners, track their survey status, send reminders, and view each joiner’s answer individually. "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAnalytics",
    "text": "Analytics",
    "translations": [
      {
        "language": "EN",
        "text": "Analytics"
      },
      {
        "language": "AR",
        "text": "التحليلات"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SurveyTemplate",
    "text": "Survey Templates",
    "translations": [
      {
        "language": "EN",
        "text": "Survey Templates"
      },
      {
        "language": "AR",
        "text": "نماذج الاستبيان"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtList",
    "text": "Joiner's List",
    "translations": [
      {
        "language": "EN",
        "text": "Joiner's List"
      },
      {
        "language": "AR",
        "text": "قائمة الموظفين الجدد"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtComparison_wellbeing",
    "text": "Ready to uncover your survey history's top well-being scores and compare them across years and companies (if any)? Discover the answer now! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج رفاهية الموظف ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن! "
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Ready to uncover your survey history's top well-being scores and compare them across years and companies (if any)? Discover the answer now! "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt360-180",
    "text": "360°/180° Assessments ",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات °360/°180"
      },
      {
        "language": "DE",
        "text": "360°/180°-Beurteilungen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "360°/180° Assessments "
      },
      {
        "language": "IT",
        "text": "Assessment 360°/180°"
      },
      {
        "language": "CS",
        "text": "Hodnocení 360°/180°"
      }
    ]
  },
  {
    "key": "txt_circle_assessment_title",
    "text": "360°/180° Assessments",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات °360/°180"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "360°/180° Assessments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurveyx",
    "text": "Survey X",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان X"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey X"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtCharGregorian",
    "text": "G",
    "translations": [
      {
        "language": "AR",
        "text": "مـ"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "G"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtHijriChar",
    "text": "H",
    "translations": [
      {
        "language": "AR",
        "text": "هـ"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "H"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Form Library",
    "text": "Form Library",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة النماذج"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Form Library"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبين"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDefault",
    "text": "Default",
    "translations": [
      {
        "language": "AR",
        "text": "اللغة الافتراضية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Standard"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Default"
      },
      {
        "language": "IT",
        "text": "Predefinito"
      },
      {
        "language": "CS",
        "text": "Výchozí"
      }
    ]
  },
  {
    "key": "txtTranslations",
    "text": "Translations",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Übersetzungen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Translations"
      },
      {
        "language": "IT",
        "text": "Traduzioni"
      },
      {
        "language": "CS",
        "text": "Překlady"
      }
    ]
  },
  {
    "key": "txtTargetLanguage",
    "text": "Target Language",
    "translations": [
      {
        "language": "AR",
        "text": "اللغة المستهدفة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Zielsprache"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Target Language"
      },
      {
        "language": "IT",
        "text": "Lingua prescelta"
      },
      {
        "language": "CS",
        "text": "Cílový jazyk"
      }
    ]
  },
  {
    "key": "txtOriginLanguage",
    "text": "Origin Language",
    "translations": [
      {
        "language": "AR",
        "text": "اللغة الأساسية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ursprungssprache"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Origin Language"
      },
      {
        "language": "IT",
        "text": "Lingua di origine"
      },
      {
        "language": "CS",
        "text": "Původní jazyk"
      }
    ]
  },
  {
    "key": "text",
    "text": "Text",
    "translations": [
      {
        "language": "AR",
        "text": "نص"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Text"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtJobProfiles",
    "text": "Job Profiles",
    "translations": [
      {
        "language": "AR",
        "text": "الملفات الوظيفية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": "Perfiles de trabajo"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Berufsbilder"
      },
      {
        "language": "PT",
        "text": "Perfis de trabalho"
      },
      {
        "language": "EN",
        "text": "Job Profiles"
      },
      {
        "language": "IT",
        "text": "Job Profile"
      },
      {
        "language": "CS",
        "text": "Popis pracovní pozice"
      }
    ]
  },
  {
    "key": "txtBrowse",
    "text": "Browse",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Durchsuchen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Browse"
      },
      {
        "language": "IT",
        "text": "Sfoglia"
      },
      {
        "language": "CS",
        "text": "Procházet"
      }
    ]
  },
  {
    "key": "txtClearHere",
    "text": "click here to",
    "translations": [
      {
        "language": "AR",
        "text": "  انقر هنا لـ"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "click here to"
      },
      {
        "language": "IT",
        "text": "clicca qui per"
      },
      {
        "language": "CS",
        "text": "klikněte zde pro"
      }
    ]
  },
  {
    "key": "txtWrongPattern",
    "text": "Email wrong pattern.",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة بريد إلكتروني خاطئة."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Email wrong pattern."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID"
      },
      {
        "language": "HI",
        "text": "ID"
      },
      {
        "language": "TA",
        "text": "ID"
      },
      {
        "language": "UR",
        "text": "ID"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "ID"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "ID"
      }
    ]
  },
  {
    "key": "txtEnterInformation",
    "text": "Fill the needed information to proceed.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة المعلومات اللازمة للمتابعة."
      },
      {
        "language": "HI",
        "text": "आगे बढ़ने के लिए आवश्यक जानकारी भरें।"
      },
      {
        "language": "TA",
        "text": "Punan ang kinakailangang impormasyon upang magpatuloy."
      },
      {
        "language": "UR",
        "text": "آگے بڑھنے کے لیے ضروری معلومات پر کریں۔"
      },
      {
        "language": "BN",
        "text": "এগিয়ে যেতে প্রয়োজনীয় তথ্য পূরণ করুন৷"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Fill the needed information to proceed."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Dropdown",
    "text": "Dropdown",
    "translations": [
      {
        "language": "AR",
        "text": "منسدلة"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Dropdown"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Show Values",
    "text": "Show Values",
    "translations": [
      {
        "language": "AR",
        "text": "عرض القيم"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Show Values"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "zobrazit hodnoty"
      }
    ]
  },
  {
    "key": "Company Size",
    "text": "Company Size",
    "translations": [
      {
        "language": "AR",
        "text": "حجم الشركة"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Company Size"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Company Name",
    "text": "Company Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الشركة"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Company Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Phone number",
    "text": "Phone number",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهاتف"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Phone number"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "job-title",
    "text": "Job Title",
    "translations": [
      {
        "language": "AR",
        "text": "المسمى الوظيفي"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Job Title"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtTEXT",
    "text": "Text",
    "translations": [
      {
        "language": "AR",
        "text": "نص"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Text"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDATE",
    "text": "Date Input",
    "translations": [
      {
        "language": "AR",
        "text": "حقل لإدخال تاريخ"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Date Input"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDROPDOWN",
    "text": "Dropdown",
    "translations": [
      {
        "language": "AR",
        "text": "منسدلة"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Dropdown"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUpgrade",
    "text": "Upgrade",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Upgrade"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Upgradovat"
      }
    ]
  },
  {
    "key": "txtDemoSection",
    "text": "Upgrade to explore all of our features",
    "translations": [
      {
        "language": "AR",
        "text": "قم بالتحديث لاستكشاف جميع ميزات زينثر"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Upgrade to explore all of our features"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Upgradujte a využijte všechny naše funkce"
      }
    ]
  },
  {
    "key": "txtUpgradeTextDesc",
    "text": "Request an upgrade to explore all of our features",
    "translations": [
      {
        "language": "AR",
        "text": "قم بطلب تحديث لاكتشاف جميع ميزات زينثر"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Request an upgrade to explore all of our features"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Požádejte o upgrade a využijte všechny naše funkce"
      }
    ]
  },
  {
    "key": "txtThisDemoAccount",
    "text": "This is a demo account",
    "translations": [
      {
        "language": "AR",
        "text": "هذا حساب تجريبي"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "This is a demo account"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Toto je demo účet"
      }
    ]
  },
  {
    "key": "txtUpgradeRequestSent",
    "text": "Upgrade request has been sent to your account manager.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال طلب التحديث لمسؤول الحساب الخاص بك."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Upgrade request has been sent to your account manager."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Žádost o upgrade byla odeslána vašemu account managerovi."
      }
    ]
  },
  {
    "key": "txtRequestUpgrade",
    "text": "Request Upgrade",
    "translations": [
      {
        "language": "AR",
        "text": "طلب تحديث"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Request Upgrade"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Požádat o upgrade"
      }
    ]
  },
  {
    "key": "txtNotNow",
    "text": "Not Now",
    "translations": [
      {
        "language": "AR",
        "text": "ليس الآن"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Not Now"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Teď ne"
      }
    ]
  },
  {
    "key": "txt_Insuffici_313",
    "text": "Insufficient Credit. Please contact your Administrator ",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد وحدات كافية. يرجى التواصل مع مسؤول النظام"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Insufficient Credit. Please contact your Administrator "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Linkhasal_237",
    "text": "Link has already been sent to the user.",
    "translations": [
      {
        "language": "AR",
        "text": "تم مشاركة الرابط مع المستجيب"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Link has already been sent to the user."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Youcandel_805",
    "text": "You can delete or add a topic to the respondents’ comments!<br><br> Note: you can have maximum of 3 topics",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك حذف أو إضافة موضوع إلى تعليقات المستجيبين! <br><br>ملحوظة: يمكنك إضافة 3 مواضيع كحد أقصى."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "You can delete or add a topic to the respondents’ comments!<br><br> Note: you can have maximum of 3 topics"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "K komentářům respondentů můžete přidávat nebo z nich odstraňovat témata!<br><br> Poznámka: Můžete mít maximálně 3 témata"
      }
    ]
  },
  {
    "key": "txt_AddDelet_480",
    "text": "Add & Delete Topics",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة وحذف مواضيع"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add & Delete Topics"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přidat a odstranit témata"
      }
    ]
  },
  {
    "key": "txt_Deleteres_201",
    "text": "Delete respondents individually or select and delete them in bulk.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بحذف المستجيبين بشكل فردي أو جماعي من خلال تحديد المُراد حذفهم."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Löschen Sie Befragte einzeln oder wählen Sie sie aus und löschen Sie sie alle."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Delete respondents individually or select and delete them in bulk."
      },
      {
        "language": "IT",
        "text": "Elimina i rispondenti individualmente o selezionali ed eliminali in blocco."
      },
      {
        "language": "CS",
        "text": "Odstranit respondenty jednotlivě nebo je vybrat a odstranit hromadně."
      }
    ]
  },
  {
    "key": "txt_DeleteRes_550",
    "text": "Delete Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "حذف مستجيب"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte löschen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Delete Respondent"
      },
      {
        "language": "IT",
        "text": "Elimina il rispondente"
      },
      {
        "language": "CS",
        "text": "Vymazat respondenta"
      }
    ]
  },
  {
    "key": "txt_Clickhere_794",
    "text": "Click here to download the list of respondents. <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل قائمة المستجيبين. <br><br>ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Liste der Befragten herunterzuladen. <br><br>Hinweis: Verfügbar im Excel-Format"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to download the list of respondents. <br><br>Note: Available in Excel format"
      },
      {
        "language": "IT",
        "text": "Clicca qui per scaricare l'elenco dei rispondenti.\n\nNota: Disponibile in formato Excel"
      },
      {
        "language": "CS",
        "text": "Klikněte zde a stáhněte si seznam respondentů. <br><br>Poznámka: K dispozici ve formátu Excel"
      }
    ]
  },
  {
    "key": "txt_Clickhere_692",
    "text": "Click here to add respondents.<br><br> Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لإضافة مستجيبين. <br><br>ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to add respondents.<br><br> Note: Available in Excel format"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Thispages_698",
    "text": "This page shows the list of respondents who have been added to be a part of the employee experience.",
    "translations": [
      {
        "language": "AR",
        "text": "تُظهر هذه الصفحة قائمة المستجيبين الذين تمت إضافتهم ليكونوا جزءًا من تجربة الموظف."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Auf dieser Seite wird die Liste der Befragten angezeigt, die hinzugefügt wurden, um Teil der Mitarbeitererfahrung zu sein."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "This page shows the list of respondents who have been added to be a part of the employee experience."
      },
      {
        "language": "IT",
        "text": "Questa pagina mostra l’elenco dei partecipanti che sono stati aggiunti all’Employee Experience."
      },
      {
        "language": "CS",
        "text": "Na této stránce je uveden seznam respondentů, kteří byli zařazeni do průzkumu spokojenosti zaměstnanců."
      }
    ]
  },
  {
    "key": "txt_Clickonth_574",
    "text": "Click on the bar to filter each driver’s/statement’s comments by sentiment type.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على الشريط لعرض تعليقات كل عامل/عبارة حسب نوع المشاعر والآراء."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click on the bar to filter each driver’s/statement’s comments by sentiment type."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kliknutím na pruh můžete filtrovat komentáře k jednotlivým faktorům/tvrzením podle typu emocí."
      }
    ]
  },
  {
    "key": "txt_DriverSen_545",
    "text": "Sentiment Filter",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية مشاعر التعليقات"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Sentiment Filter"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Filtr emocí"
      }
    ]
  },
  {
    "key": "txt_Clickhere_441",
    "text": "Click here to expand the comments under each driver/question.<br><br> Note: all comments are anonymous!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التعليقات تحت كل عامل أو سؤال. <br><br>ملحوظة: جميع التعليقات مجهولة الهوية!"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here to expand the comments under each driver/question.<br><br> Note: all comments are anonymous!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kliknutím sem rozbalíte komentáře pod jednotlivými faktory/otázkami.<br><br> Poznámka: všechny komentáře jsou anonymní!"
      }
    ]
  },
  {
    "key": "txt_ViewComme_499",
    "text": "View Comments",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التعليقات"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "View Comments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "zobrazit komentáře "
      }
    ]
  },
  {
    "key": "txt_Clickhere_158",
    "text": "Click here and select from the dropdown to filter all comments by sentiment type (positive, neutral, negative).",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا للاختيار من القائمة المنسدلة لتصفية جميع التعليقات حسب نوع المشاعر والآراء الإيجابية/المعتدلة/السلبية."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click here and select from the dropdown to filter all comments by sentiment type (positive, neutral, negative)."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kliknutím sem a výběrem z rozevíracího seznamu můžete filtrovat všechny komentáře podle typu sentimentu (pozitivní, neutrální, negativní)."
      }
    ]
  },
  {
    "key": "txt_Sentiment_431",
    "text": "Sentiment Filter",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية المشاعر"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Sentiment Filter"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Filtr emocí"
      }
    ]
  },
  {
    "key": "txt_Clickonth_970",
    "text": "Click on the bubble to filter the comments by topic.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على الفقاعة ليتم تصفية محتوى التعليقات بحسب الموضوع المختار."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click on the bubble to filter the comments by topic."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kliknutím na bublinu můžete filtrovat komentáře podle tématu."
      }
    ]
  },
  {
    "key": "txt_TopicFilt_926",
    "text": "Topic Filter",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية الموضوع"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Topic Filter"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Filtr témat"
      }
    ]
  },
  {
    "key": "txt_Responden_818",
    "text": "Respondent Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات المستجيب"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondent Information"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Selectfro_459",
    "text": "You can create additional criteria.<br>Fill in the criterion name and its options.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية.<br> قم بتعبئة اسم المعيار وخياراته التابعة."
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "You can create additional criteria.<br>Fill in the criterion name and its options."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Můžete vytvořit další kritéria.<br>Zadejte název kritéria a jeho možnosti."
      }
    ]
  },
  {
    "key": "txt_Predefine_865",
    "text": "Custom Criteria",
    "translations": [
      {
        "language": "AR",
        "text": " معايير مخصصة"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Custom Criteria"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vlastní kritéria"
      }
    ]
  },
  {
    "key": "txtQuestion",
    "text": "Question",
    "translations": [
      {
        "language": "AR",
        "text": "سؤال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Question"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "TR",
        "text": "Soru"
      },
      {
        "language": "CS",
        "text": "Otázka"
      }
    ]
  },
  {
    "key": "txt_back_arrow",
    "text": "<",
    "translations": [
      {
        "language": "AR",
        "text": "<"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "<"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_next_arrow",
    "text": ">",
    "translations": [
      {
        "language": "AR",
        "text": ">"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": ">"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Next"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "TR",
        "text": "Sonraki"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_start_tour",
    "text": "Start Tour",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ الجولة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Start Tour"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_end_tour",
    "text": "End Tour",
    "translations": [
      {
        "language": "AR",
        "text": "إنهاء الجولة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "End Tour"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_skip",
    "text": "Skip",
    "translations": [
      {
        "language": "AR",
        "text": "تخطى"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Skip"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_no_sentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "No Sentiment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_neutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Neutral"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_negative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Negative"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_positive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Positive"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtRegenerateWithAI",
    "text": "Regenerate by Zenithr AI",
    "translations": [
      {
        "language": "AR",
        "text": "تجديد مع زينثر آي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Regenerate with Zenithr AI"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUploaded",
    "text": "Uploaded",
    "translations": [
      {
        "language": "AR",
        "text": "تم الرفع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Uploaded"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nahráno"
      }
    ]
  },
  {
    "key": "txt_uploadthepremade",
    "text": "upload the premade",
    "translations": [
      {
        "language": "EN",
        "text": "upload the premade"
      },
      {
        "language": "AR",
        "text": "تحميل الجدول المُعرف مسبقاً"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nahrát předdefinovanou šablonu"
      }
    ]
  },
  {
    "key": "txt_Downloadthepremade",
    "text": "Download the premade",
    "translations": [
      {
        "language": "EN",
        "text": "Download the premade"
      },
      {
        "language": "AR",
        "text": "تنزيل الجدول المُعرف مسبقاً"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stáhnout předdefinovanou šablonu"
      }
    ]
  },
  {
    "key": "txt_Uploading",
    "text": "Uploading",
    "translations": [
      {
        "language": "EN",
        "text": "Uploading"
      },
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Probíhá nahrávání"
      }
    ]
  },
  {
    "key": "txtLeftSeconds",
    "text": "seconds left",
    "translations": [
      {
        "language": "AR",
        "text": "ثانية متبقية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "seconds left"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "zbývá sekund"
      }
    ]
  },
  {
    "key": "txtAbort",
    "text": "Abort",
    "translations": [
      {
        "language": "AR",
        "text": "إحباط"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Abort"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zrušit"
      }
    ]
  },
  {
    "key": "txt_TemplateDownload",
    "text": "Template Download",
    "translations": [
      {
        "language": "EN",
        "text": "Template Download"
      },
      {
        "language": "AR",
        "text": "تنزيل النموذج"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stáhnout šablonu"
      }
    ]
  },
  {
    "key": "txt_TemplateUpload",
    "text": "Template Upload",
    "translations": [
      {
        "language": "EN",
        "text": "Template Upload"
      },
      {
        "language": "AR",
        "text": "تحميل النموذج"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nahrát šablonu"
      }
    ]
  },
  {
    "key": "txtInvalidAiText",
    "text": "Invalid text",
    "translations": [
      {
        "language": "AR",
        "text": "نص غير صالح"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Invalid text"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtGenerateWithAI",
    "text": "Generate by Zenithr AI",
    "translations": [
      {
        "language": "AR",
        "text": "انشئ مع زينثر آي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Generieren Sie mit Zenithr AI"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Generate with Zenithr AI"
      },
      {
        "language": "IT",
        "text": "Genera con Zenithr AI"
      },
      {
        "language": "CS",
        "text": "Vytvořit pomocí AA+ AI"
      }
    ]
  },
  {
    "key": "txtGenerateByAi",
    "text": "Generate by Zenithr AI",
    "translations": [
      {
        "language": "AR",
        "text": "أنشئ من خلال زينثر أي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Generiert von Zenithr AI"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Generate by Zenithr AI"
      },
      {
        "language": "IT",
        "text": "Genera da Zenithr AI"
      },
      {
        "language": "CS",
        "text": "Vytvořit pomocí AA+ AI"
      }
    ]
  },
  {
    "key": "txtNoSentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "No Sentiment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Bez emocí"
      }
    ]
  },
  {
    "key": "Monthly",
    "text": "Monthly",
    "translations": [
      {
        "language": "AR",
        "text": "شهري"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Monthly"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Quarterly",
    "text": "Quarterly",
    "translations": [
      {
        "language": "AR",
        "text": "ربع سنوي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Quarterly"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Yearly",
    "text": "Yearly",
    "translations": [
      {
        "language": "AR",
        "text": "سنوي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Yearly"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Generation"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "TenureGroup",
    "text": "Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة سنوات الخدمة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Tenure Group"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "المجموعة العمرية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Age Group"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Nationality"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Gender"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grade",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الوظيفية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Job Grade"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "PerformanceRate",
    "text": "Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Performance Rate"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "المستوى الوظيفي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Band Level"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_copy",
    "text": "Copy",
    "translations": [
      {
        "language": "AR",
        "text": "نسخ"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Copy"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurveyX",
    "text": "Survey-X",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey-X"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtShowMore",
    "text": "Show More ...",
    "translations": [
      {
        "language": "AR",
        "text": "عرض المزيد..."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Show More ..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit více ..."
      }
    ]
  },
  {
    "key": "txtReupload",
    "text": "Reupload File",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة التحميل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Datei erneut hochladen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reupload File"
      },
      {
        "language": "IT",
        "text": "Ricarica il file"
      },
      {
        "language": "CS",
        "text": "Znovu nahrát soubor"
      }
    ]
  },
  {
    "key": "txtTopicName",
    "text": "Topic Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الموضوع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Topic Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Název tématu"
      }
    ]
  },
  {
    "key": "txtCreateTopic",
    "text": "Create Topic",
    "translations": [
      {
        "language": "AR",
        "text": "أنشئ موضوع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Create Topic"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vytvořit téma"
      }
    ]
  },
  {
    "key": "txtNewTopic",
    "text": "New Topic",
    "translations": [
      {
        "language": "AR",
        "text": "موضوع جديد"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Topic"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nové téma"
      }
    ]
  },
  {
    "key": "txt_ProcessNo_814",
    "text": "Process Notifications",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط الإشعارات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Process Notifications"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_uploading",
    "text": "Uploading...",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحميل..."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Uploading..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "user-notification-psychometric-respondents-upload",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "user-notification-psychometric",
    "text": "Thomas Hub Insights",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Thomas Hub Insights"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSelectTopic",
    "text": "Select Topic",
    "translations": [
      {
        "language": "AR",
        "text": "حدد الموضوع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select Topic"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vybrat téma"
      }
    ]
  },
  {
    "key": "txtSelectTopicDesc",
    "text": "Select a Topic from the list below:",
    "translations": [
      {
        "language": "AR",
        "text": "حدد موضوعًا من القائمة أدناه:"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select a Topic from the list below:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyberte téma z níže uvedeného seznamu:"
      }
    ]
  },
  {
    "key": "txtAddTopic",
    "text": "Add Topic",
    "translations": [
      {
        "language": "AR",
        "text": "أضف موضوع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Topic"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přidat téma"
      }
    ]
  },
  {
    "key": "minMaxQuestionsLength",
    "text": "Choose minimum [minCount] and maximum [maxCount] ",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الحد الأدنى [minCount] والحد الأقصى [maxCount]"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Choose minimum [minCount] and maximum [maxCount] "
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte minimální počet [minCount] a maximální počet [maxCount]"
      }
    ]
  },
  {
    "key": "maxQuestionsLength",
    "text": "Choose maximum [maxCount] options",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الحد الأقصى للخيارات [maxCount]."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Choose maximum [maxCount] options"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte maximální počet [maxCount] možností"
      }
    ]
  },
  {
    "key": "minQuestionsLength",
    "text": "Choose minimum [minCount] options",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الحد الأدنى من خيارات [minCount]."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Choose minimum [minCount] options"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte minimální počet [minCount] možností"
      }
    ]
  },
  {
    "key": "txt_heatmap_enps_score",
    "text": "eNPS",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين (eNPS)"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "eNPS"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_heatmap_overall_score",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "المعدل الكلي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Thomas Products",
    "text": "Zenithr Solutions",
    "translations": [
      {
        "language": "AR",
        "text": "حلول زينثر"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Zenithr Solutions"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_INACTIVE",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Inactive"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtTemplate",
    "text": "Survey Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج الاستبيان"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Templates"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtRespondentsFillCriteria",
    "text": "Require respondents to fill criteria",
    "translations": [
      {
        "language": "AR",
        "text": "تفعيل تعبئة المعايير من قبل المستجيبين"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Fordern Sie die Befragten auf, Kriterien zu erfüllen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Require respondents to fill criteria"
      },
      {
        "language": "IT",
        "text": "Richiedi ai rispondenti di selezionare i criteri richiesti"
      },
      {
        "language": "CS",
        "text": "Požadovat, aby respondenti splňovali kritéria"
      }
    ]
  },
  {
    "key": "txt_preview_sample_desc",
    "text": "Preview Sample",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Preview Sample"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DELETED",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Inactive"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtExtraQuestionPreview",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Question Preview"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtNewQuestion",
    "text": "New statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New statement"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtHelpCenter",
    "text": "Help Center",
    "translations": [
      {
        "language": "AR",
        "text": "  مركز الدعم"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Hilfecenter"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Help Center"
      },
      {
        "language": "IT",
        "text": "Centro assistenza"
      },
      {
        "language": "CS",
        "text": "Centrum nápovědy"
      }
    ]
  },
  {
    "key": "txtExtraQuestion",
    "text": " I feel motivated and inspired at the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بالتحفيز والإلهام في بيئة العمل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": " I feel motivated and at inspired at the workplace"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtHavemorecomments",
    "text": "Have more comments?",
    "translations": [
      {
        "language": "AR",
        "text": "لديك المزيد من التعليقات؟"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Have more comments?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Sample_Question",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج السؤال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Sample Question"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TopicName_419",
    "text": "Topic Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الموضوع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Topic Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CreateTop_928",
    "text": "Create Topic",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء موضوع"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Create Topic"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NewTopic_464",
    "text": "New Topic",
    "translations": [
      {
        "language": "AR",
        "text": "موضوع جديد"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Topic"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtProvideEndDate",
    "text": "An end date needs to be provided",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تحديد تاريخ الانتهاء"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "An end date needs to be provided"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUpdateSurveyEnddateAndReminders",
    "text": "Update survey end date and reminders.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث تاريخ إكمال الاستبيان والتذكيرات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Update survey end date and reminders."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUpdateDates",
    "text": "Update Dates",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Update Dates"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Data aktualizace"
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Deleted Successfully!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_start_and_endDate",
    "text": "Please, add start date and end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة تاريخ البدء وتاريخ الانتهاء."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Please, add start date and end date."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte prosím datum zahájení a datum ukončení."
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reminder Date"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Datum připomenutí"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Reminder"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUpdateReminders",
    "text": "Update Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التذكيرات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Update Reminders"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Aktualizovat připomenutí"
      }
    ]
  },
  {
    "key": "txtUpdateTimeFrame",
    "text": "Update Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث المدة الزمنية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Update Timeframe"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Aktualizovat časový rámec"
      }
    ]
  },
  {
    "key": "txtUpdateSurveyDates",
    "text": "Update Survey Dates",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث تواريخ الاستبيان"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Update Survey Dates"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Aktualizovat data průzkumu"
      }
    ]
  },
  {
    "key": "txt_delete_item_confirmation_message",
    "text": "Are you sure you want to permanently remove this item?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا العنصر نهائياً؟"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Are you sure you want to permanently remove this item?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_STARTED",
    "text": "In-Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In-Progress"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Confirmation"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDeleteCriteria",
    "text": "Are you sure you want to delete this criteria?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا المعيار؟"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this criteria?"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_save_changes",
    "text": "Save Changes",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ التغييرات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Änderungen speichern"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Save Changes"
      },
      {
        "language": "IT",
        "text": "Salva le modifiche"
      },
      {
        "language": "CS",
        "text": "Uložit změny"
      }
    ]
  },
  {
    "key": "txt_max_characters",
    "text": "Max Characters",
    "translations": [
      {
        "language": "AR",
        "text": "الحد الأقصى لعدد الأحرف"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Max Characters"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_required",
    "text": "Required",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Required"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_question_props",
    "text": "Question Properties",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات السؤال"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Question Properties"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ExportasP_197",
    "text": "Export as PDF",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل ملف PDF"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Export as PDF"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtPage",
    "text": "Page",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Page"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stránka"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Progress"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtResponded",
    "text": "Responded",
    "translations": [
      {
        "language": "AR",
        "text": "استجاب منهم"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Responded"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Rename"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtWellbeing",
    "text": "Employee Well-Being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Well-Being"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_user_exists_message",
    "text": "Email already in use",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني مستخدم بالفعل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Email already in use"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_user_exists_subject",
    "text": "Error",
    "translations": [
      {
        "language": "AR",
        "text": "تنبيه"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Error"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtOnboarding",
    "text": "Employee Onboarding",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد وتهيئة الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Onboarding"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSelectOption",
    "text": "Select Option",
    "translations": [
      {
        "language": "AR",
        "text": "اختر خيار"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select Option"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyberte možnost"
      }
    ]
  },
  {
    "key": "success",
    "text": "success",
    "translations": [
      {
        "language": "AR",
        "text": "تم"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "success"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "warning",
    "text": "warning",
    "translations": [
      {
        "language": "AR",
        "text": "تحذير"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "warning"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "info",
    "text": "info",
    "translations": [
      {
        "language": "AR",
        "text": "معلومة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "info"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "error",
    "text": "error",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "error"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtRemoveSelection",
    "text": "Remove Selection",
    "translations": [
      {
        "language": "AR",
        "text": "أزل الاختيارات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Auswahl entfernen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Remove Selection"
      },
      {
        "language": "IT",
        "text": "Rimuovi la selezione"
      },
      {
        "language": "CS",
        "text": "Zrušit výběr"
      }
    ]
  },
  {
    "key": "txt_Exit_Questionnaire",
    "text": "Employee Exit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان خروج الموظف"
      },
      {
        "language": "FR",
        "text": "Enquęte sur les sorties des employés"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Exit Survey"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průzkum při odchodu zaměstnance"
      }
    ]
  },
  {
    "key": "Select all that apply",
    "text": "Select all that apply",
    "translations": [
      {
        "language": "AR",
        "text": "اختر كل ما ينطبق"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select all that apply"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyberte všechny příslušné možnosti"
      }
    ]
  },
  {
    "key": "txtOverallScore",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة الكلية"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gesamtpunktzahl"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall Score"
      },
      {
        "language": "IT",
        "text": "Punteggio complessivo"
      },
      {
        "language": "CS",
        "text": "Celkové skóre"
      }
    ]
  },
  {
    "key": "txtValue",
    "text": "Value",
    "translations": [
      {
        "language": "AR",
        "text": "القيمة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wert"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Value"
      },
      {
        "language": "IT",
        "text": "Valore"
      },
      {
        "language": "CS",
        "text": "Hodnota"
      }
    ]
  },
  {
    "key": "txt_answers",
    "text": "Options",
    "translations": [
      {
        "language": "AR",
        "text": "الإجابات"
      },
      {
        "language": "FR",
        "text": "Options"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Optionen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Options"
      },
      {
        "language": "IT",
        "text": "Opzioni"
      },
      {
        "language": "CS",
        "text": "Možnosti"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "بشكل عام"
      },
      {
        "language": "FR",
        "text": "En Général"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkově"
      }
    ]
  },
  {
    "key": "txtGroup",
    "text": "Group",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة"
      },
      {
        "language": "FR",
        "text": "Groupe "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Group"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtsuccess",
    "text": "Success",
    "translations": [
      {
        "language": "AR",
        "text": "تمت العملية بنجاح"
      },
      {
        "language": "FR",
        "text": "Succčs"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Erfolg"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Success"
      },
      {
        "language": "IT",
        "text": "Successo"
      },
      {
        "language": "CS",
        "text": "Úspěch"
      }
    ]
  },
  {
    "key": "txtwarning",
    "text": "Warning",
    "translations": [
      {
        "language": "AR",
        "text": "تنبيه"
      },
      {
        "language": "FR",
        "text": "Avertissement"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Warnung"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Warning"
      },
      {
        "language": "IT",
        "text": "Attenzione"
      },
      {
        "language": "CS",
        "text": "Varování"
      }
    ]
  },
  {
    "key": "txtalert",
    "text": "Alert",
    "translations": [
      {
        "language": "AR",
        "text": "تنبيه"
      },
      {
        "language": "FR",
        "text": "Avertissement"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alarm"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Alert"
      },
      {
        "language": "IT",
        "text": "Avviso"
      },
      {
        "language": "CS",
        "text": "Upozornění"
      }
    ]
  },
  {
    "key": "txterror",
    "text": "Error",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ"
      },
      {
        "language": "FR",
        "text": "Erreur"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Fehler"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Error"
      },
      {
        "language": "IT",
        "text": "Errore"
      },
      {
        "language": "CS",
        "text": "Chyba"
      }
    ]
  },
  {
    "key": "txtContactSoon",
    "text": "We'll be in contact with you soon.",
    "translations": [
      {
        "language": "AR",
        "text": "سوف يتم الاتصال بك قريباً"
      },
      {
        "language": "FR",
        "text": "Nous serons bientôt en contact avec vous "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wir werden uns in Kürze mit Ihnen in Verbindung setzen."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "We'll be in contact with you soon."
      },
      {
        "language": "IT",
        "text": "Ti contatteremo presto."
      },
      {
        "language": "CS",
        "text": "Brzy se vám ozveme."
      }
    ]
  },
  {
    "key": "txtNewBalance",
    "text": "New Balance",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد الجديد"
      },
      {
        "language": "FR",
        "text": "Nouveau Solde"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neuer Kontostand"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Balance"
      },
      {
        "language": "IT",
        "text": "Nuovo saldo"
      },
      {
        "language": "CS",
        "text": "Nový zůstatek"
      }
    ]
  },
  {
    "key": "txtRequestAmount",
    "text": "Request Amount",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد المطلوب"
      },
      {
        "language": "FR",
        "text": "Solde requis"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Angeforderte Menge"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Request Amount"
      },
      {
        "language": "IT",
        "text": "Quantità richiesta"
      },
      {
        "language": "CS",
        "text": "Požadované množství"
      }
    ]
  },
  {
    "key": "txtCurrentBalance",
    "text": "Current Balance",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد الحالي"
      },
      {
        "language": "FR",
        "text": "SOLDE courant"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Aktueller Kontostand"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Current Balance"
      },
      {
        "language": "IT",
        "text": "Saldo attuale"
      },
      {
        "language": "CS",
        "text": "Aktuální zůstatek"
      }
    ]
  },
  {
    "key": "txt180DegreeFeedback",
    "text": "180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "FR",
        "text": "Commentaire ŕ 180°"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "180° Feedback"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt360DegreeFeedback",
    "text": "360° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360"
      },
      {
        "language": "FR",
        "text": "Commentaire ŕ 360°"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "360° Feedback"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zpětná vazba 360"
      }
    ]
  },
  {
    "key": "txtRequestSent",
    "text": "Request has been sent!",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تم إرسال طلبك!"
      },
      {
        "language": "FR",
        "text": "Votre demande a été envoyée !"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Anfrage wurde gesendet!"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Request has been sent!"
      },
      {
        "language": "IT",
        "text": "La richiesta è stata inviata!"
      },
      {
        "language": "CS",
        "text": "Žádost byla odeslána!"
      }
    ]
  },
  {
    "key": "txtAccountOverview",
    "text": "Account Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على الحساب"
      },
      {
        "language": "FR",
        "text": "Aperçu du Compte"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kontoübersicht"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Account Overview"
      },
      {
        "language": "IT",
        "text": "Panoramica dell'account"
      },
      {
        "language": "CS",
        "text": "Přehled účtu"
      }
    ]
  },
  {
    "key": "btnRequestUnits",
    "text": "Request Units",
    "translations": [
      {
        "language": "AR",
        "text": "طلب وحدات"
      },
      {
        "language": "FR",
        "text": "Demande d'Unités"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "angeforderte Units"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Request Units"
      },
      {
        "language": "IT",
        "text": "Richiedi le unità"
      },
      {
        "language": "CS",
        "text": "Objednat jednotky"
      }
    ]
  },
  {
    "key": "txtInsufficientUnits",
    "text": "Insufficient Units!",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد لديك وحدات كافية!"
      },
      {
        "language": "FR",
        "text": "Unités insuffisantes!"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Nicht genügend Units!"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Insufficient Units!"
      },
      {
        "language": "IT",
        "text": "Unità insufficienti!"
      },
      {
        "language": "CS",
        "text": "Nedostatek jednotek!"
      }
    ]
  },
  {
    "key": "txtYourcurrentbalance",
    "text": "Your current balance is",
    "translations": [
      {
        "language": "AR",
        "text": "رصيدك الحالي هو"
      },
      {
        "language": "FR",
        "text": "Votre solde actuel est"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your current balance is"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtunits",
    "text": "units",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unités"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Units"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "units"
      },
      {
        "language": "IT",
        "text": "unità"
      },
      {
        "language": "CS",
        "text": "jednotky"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Email (Courrier électronique)"
      },
      {
        "language": "HI",
        "text": "ईमेल"
      },
      {
        "language": "TA",
        "text": "Email"
      },
      {
        "language": "UR",
        "text": "ای میل"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Email"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "email"
      }
    ]
  },
  {
    "key": "txtCustomizeTable",
    "text": "Customize Table",
    "translations": [
      {
        "language": "AR",
        "text": "عدِِل الجدول"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Customize Table"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtclicktogotoaccount",
    "text": "You do not have a sufficient amount of units to proceed with creating a new survey / assessment. To request more units, click on the button below.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد لديك وحدات كافية لإتمام إنشاء استبيان / تقييم جديد، لطلب وحدات إضافية، اضغط على الزر أدناه."
      },
      {
        "language": "FR",
        "text": "UVous n’avez pas un nombre suffisant d’unités pour procéder à la création d’un nouveau Enquête / évaluation. Pour demander plus d’unités, cliquez sur le bouton ci-dessous."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie verfügen nicht über genügend Units, um mit der Erstellung einer neuen Umfrage/Assessment fortzufahren. Um weitere Units anzufordern, klicken Sie auf die Schaltfläche unten."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "You do not have a sufficient amount of units to proceed with creating a new survey / assessment. To request more units, click on the button below."
      },
      {
        "language": "IT",
        "text": "Non hai un numero sufficiente di unità per procedere con la creazione di una/un nuova/nuovo survey/Assessment. Per richiedere più unità, clicca sul pulsante qui sotto."
      },
      {
        "language": "CS",
        "text": "Nemáte k dispozici dostatek jednotek k vytvoření nového hodnocení. Chcete-li požádat o další jednotky, klikněte na tlačítko níže."
      }
    ]
  },
  {
    "key": "txtRequest",
    "text": "Request",
    "translations": [
      {
        "language": "AR",
        "text": "اطلب"
      },
      {
        "language": "FR",
        "text": "Demandez"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Anfrage"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Request"
      },
      {
        "language": "IT",
        "text": "Richiesta"
      },
      {
        "language": "CS",
        "text": "Žádost "
      }
    ]
  },
  {
    "key": "txtYourcurrentbalanceforsurvey",
    "text": "Your current balance for this survey is",
    "translations": [
      {
        "language": "AR",
        "text": "رصيدك الحالي لهذا الاستبيان هو"
      },
      {
        "language": "FR",
        "text": "Votre solde actuel pour ce Enquęte est"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ihr aktueller Kontostand für diese Umfrage beträgt"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Your current balance for this survey is"
      },
      {
        "language": "IT",
        "text": "Il tuo saldo attuale per questa survey è "
      },
      {
        "language": "CS",
        "text": "Váš aktuální zůstatek za tento průzkum činí"
      }
    ]
  },
  {
    "key": "txtthissurveyrequires",
    "text": "units, this survey requires at least",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة, هذا الاستبيان يحتاج على الأقل"
      },
      {
        "language": "FR",
        "text": "this survey requires at least"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Für diese Umfrage erforderliche Units"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "units, this survey requires at least"
      },
      {
        "language": "IT",
        "text": "unità, questa survey richiede almeno "
      },
      {
        "language": "CS",
        "text": "jednotek, tento průzkum vyžaduje alespoň"
      }
    ]
  },
  {
    "key": "txt_employee_exit",
    "text": "Employee Exit",
    "translations": [
      {
        "language": "AR",
        "text": "خروج الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Exit"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Odchod zaměstnanců"
      }
    ]
  },
  {
    "key": "txtSurveyRespondentList",
    "text": "Survey Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون للاستبيان"
      },
      {
        "language": "FR",
        "text": "Liste des Répondants au Enquęte "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Respondents List"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Seznam respondentů průzkumu"
      }
    ]
  },
  {
    "key": "txt_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق"
      },
      {
        "language": "FR",
        "text": "Fermer"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Schließen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Close"
      },
      {
        "language": "IT",
        "text": "Chiudi"
      },
      {
        "language": "CS",
        "text": "Zavřít"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "FR",
        "text": "Nom "
      },
      {
        "language": "HI",
        "text": "नाम"
      },
      {
        "language": "TA",
        "text": "Pangalan"
      },
      {
        "language": "UR",
        "text": "نام"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jméno"
      }
    ]
  },
  {
    "key": "txtLeaverAnswerReport",
    "text": "Leaver Answer Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير أجوبة المغادر"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Leaver Answer Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtJoinerAnswerReport",
    "text": "Joiner Answer Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير أجوبة المغادر"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Joiner Answer Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা প্রশ্ন"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Questions"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_new_section",
    "text": "Add New Section",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة جزء"
      },
      {
        "language": "FR",
        "text": "Ajouter une Nouvelle Section"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add New Section"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_section_name",
    "text": "Section Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الجزء"
      },
      {
        "language": "FR",
        "text": "Nom de la Section"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Section Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_question_name",
    "text": "Question Name",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان السؤال"
      },
      {
        "language": "FR",
        "text": "Titre de la Question"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Question Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_question_type",
    "text": "Question Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع السؤال"
      },
      {
        "language": "FR",
        "text": "Type de Question"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Question Type"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtIsSkippable",
    "text": "Is Skippable",
    "translations": [
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Is Skippable"
      },
      {
        "language": "AR",
        "text": "قابل للتخطي"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtIsEngagement",
    "text": "Is Engagement",
    "translations": [
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Is Engagement"
      },
      {
        "language": "AR",
        "text": "هل الاندماج"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_add_question",
    "text": "Add Question",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة سؤال"
      },
      {
        "language": "FR",
        "text": "Ajouter une Question"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Question"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_heading_name",
    "text": "Heading Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم العنوان"
      },
      {
        "language": "FR",
        "text": "Titre"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Heading Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_other_answer",
    "text": "Other",
    "translations": [
      {
        "language": "AR",
        "text": "غير ذلك"
      },
      {
        "language": "FR",
        "text": "Autre"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Other"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_option_name",
    "text": "Option Name",
    "translations": [
      {
        "language": "AR",
        "text": "الخيار"
      },
      {
        "language": "FR",
        "text": "Nom de l'Option"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Option Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      },
      {
        "language": "FR",
        "text": "#UNITS# les unités seront déduites pour cette action"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Für diese Aktion werden #UNITS# Units abgezogen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "#UNITS# units will be deducted for this action"
      },
      {
        "language": "IT",
        "text": "#UNITS# unità saranno detratte per questa azione"
      },
      {
        "language": "CS",
        "text": "Za tuto akci bude odečteno #UNITS# jednotek"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Okay"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Okay"
      },
      {
        "language": "IT",
        "text": "Ok"
      },
      {
        "language": "CS",
        "text": "OK"
      }
    ]
  },
  {
    "key": "txtEngagement",
    "text": "Employee Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Engagement de l'Employé"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Engagement"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zapojení zaměstnanců"
      }
    ]
  },
  {
    "key": "txt_step",
    "text": "STEP",
    "translations": [
      {
        "language": "AR",
        "text": "خطوة"
      },
      {
        "language": "FR",
        "text": "ETAPE"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "SCHRITT"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "STEP"
      },
      {
        "language": "IT",
        "text": "FASE"
      },
      {
        "language": "CS",
        "text": "KROK"
      }
    ]
  },
  {
    "key": "txt_step1",
    "text": "Click \"Download file\" to download the premade spreadsheet (.xlsx).",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على زر \"تحميل الملف\" لتحميل جدول بيانات فارغ (.xlsx)"
      },
      {
        "language": "FR",
        "text": "Cliquez sur «Télécharger le fichier» pour télécharger la feuille de calcul préfabriquée (.xlsx)."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click \"Download file\" to download the premade spreadsheet (.xlsx)."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Klikněte na „Stáhnout soubor“ a stáhněte si předem připravenou tabulku (.xlsx)."
      }
    ]
  },
  {
    "key": "txt_step2",
    "text": "Fill out the premade template and save it.",
    "translations": [
      {
        "language": "AR",
        "text": "املأ جدول بيانات الذي تم تحميله واحفظه"
      },
      {
        "language": "FR",
        "text": "Remplissez le modčle prédéfini et enregistrez-le."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Fill out the premade template and save it."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyplňte předem připravenou šablonu a uložte ji."
      }
    ]
  },
  {
    "key": "txt_step3",
    "text": "Click \"Upload File\" to upload the filled out spreadsheet.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على زر \"رفع الملف\" لرفع جدول البيانات الذي تم تعبئته (.xlsx)"
      },
      {
        "language": "FR",
        "text": "Cliquez sur \"Télécharger le fichier\"pour télécharger la feuille de calcul remplie."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Click \"Upload File\" to upload the filled out spreadsheet."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Klikněte na „Nahrát soubor“ a nahrajte vyplněnou tabulku."
      }
    ]
  },
  {
    "key": "btn_download",
    "text": "Download file",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الملف"
      },
      {
        "language": "FR",
        "text": "Télécharger un fichier"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Datei herunterladen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download file"
      },
      {
        "language": "IT",
        "text": "Scarica il file"
      },
      {
        "language": "CS",
        "text": "Stáhnout soubor"
      }
    ]
  },
  {
    "key": "txt_auto_return",
    "text": "Once the data has been uploaded, the page will return to the respondents list.",
    "translations": [
      {
        "language": "AR",
        "text": "عند الانتهاء من رفع بياناتك، ستعود لقائمة المستجيبون تلقائياً!"
      },
      {
        "language": "FR",
        "text": "the page will return to the respondents list."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Once the data has been uploaded, the page will return to the respondents list."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jakmile budou data nahrána, stránka se vrátí k seznamu respondentů."
      }
    ]
  },
  {
    "key": "btn_upload_file",
    "text": "Upload File",
    "translations": [
      {
        "language": "AR",
        "text": "رفع الملف"
      },
      {
        "language": "FR",
        "text": "Télécharger un fichier"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Datei hochladen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Upload File"
      },
      {
        "language": "IT",
        "text": "Carica il file"
      },
      {
        "language": "CS",
        "text": "Nahrát soubor"
      }
    ]
  },
  {
    "key": "btn_import_file",
    "text": "Import File",
    "translations": [
      {
        "language": "AR",
        "text": "رفع الملف"
      },
      {
        "language": "FR",
        "text": "Importer le Fichier"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Import File"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Načíst soubor"
      }
    ]
  },
  {
    "key": "btn_add_respondent",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Répondant"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Respondent"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přidat respondenta"
      }
    ]
  },
  {
    "key": "txtTotal",
    "text": "Total ",
    "translations": [
      {
        "language": "AR",
        "text": "المجموع"
      },
      {
        "language": "FR",
        "text": "Total "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gesamt"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Total "
      },
      {
        "language": "IT",
        "text": "Totale"
      },
      {
        "language": "CS",
        "text": "Celkem"
      }
    ]
  },
  {
    "key": "txtEmployeeHappiness",
    "text": "Employee Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة الموظف"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Happiness"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Spokojenost zaměstnanců"
      }
    ]
  },
  {
    "key": "btn_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      },
      {
        "language": "FR",
        "text": "Ajouter"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_add_option",
    "text": "Add Option",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة خيار"
      },
      {
        "language": "FR",
        "text": "Ajouter une Option"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Option hinzufügen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Option"
      },
      {
        "language": "IT",
        "text": "Aggiungi un'opzione"
      },
      {
        "language": "CS",
        "text": "Přidat možnost"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "FR",
        "text": "De"
      },
      {
        "language": "BN",
        "text": "এর"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "von"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "of"
      },
      {
        "language": "IT",
        "text": "di"
      },
      {
        "language": "CS",
        "text": "z"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Delete"
      },
      {
        "language": "IT",
        "text": "Elimina"
      },
      {
        "language": "CS",
        "text": "Vymazat"
      }
    ]
  },
  {
    "key": "txt_optional",
    "text": "(optional)",
    "translations": [
      {
        "language": "AR",
        "text": "(اختياري)"
      },
      {
        "language": "FR",
        "text": "(Optionnel)"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "(optional)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_optional_criteria_description",
    "text": "Select predefined criteria or create your own.",
    "translations": [
      {
        "language": "AR",
        "text": "اختار من المعايير المحددة مسبقاً أو أنشئ المعايير الخاصة بك:"
      },
      {
        "language": "FR",
        "text": "Sélectionnez des critčres prédéfinis ou créez les vôtres."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wählen Sie vordefinierte Kriterien aus oder erstellen Sie Ihre eigenen."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select predefined criteria or create your own."
      },
      {
        "language": "IT",
        "text": "Scegli un criterio predefinito oppure creane uno personalizzato."
      },
      {
        "language": "CS",
        "text": "Vyberte předdefinovaná kritéria nebo si vytvořte vlastní."
      }
    ]
  },
  {
    "key": "txt_new_criteria",
    "text": "New Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معيار جديد"
      },
      {
        "language": "FR",
        "text": "Nouveaux Critčres"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neue Kriterien"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Criteria"
      },
      {
        "language": "IT",
        "text": "Nuovo criterio"
      },
      {
        "language": "CS",
        "text": "Nová kritéria"
      }
    ]
  },
  {
    "key": "txt_selected_criteria",
    "text": "Selected criteria will require additional input during respondent setup.",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التي تم اختيارها ستتطلب المزيد من الإعدادات أثناء إضافة المستجيبون."
      },
      {
        "language": "FR",
        "text": "Les critères sélectionnés nécessiteront des commentaires supplémentaires pendant la configuration du répondant."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Selected criteria will require additional input during respondent setup."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      },
      {
        "language": "FR",
        "text": "Fermer"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Schließen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Close"
      },
      {
        "language": "IT",
        "text": "Chiudi"
      },
      {
        "language": "CS",
        "text": "Zavřít"
      }
    ]
  },
  {
    "key": "txt_answers_description",
    "text": "Options will be shown in a drop down list. A respondent may select only one option.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم عرض الإجابات كخيارات (سيتم اختيار إجابة واحدة فقط من قبل المستجيب)"
      },
      {
        "language": "FR",
        "text": "Les options seront affichées dans une liste déroulante. Un répondant ne peut sélectionner qu'une seule option."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Die Optionen werden in einer Dropdown-Liste angezeigt. Ein Befragter kann nur eine Option auswählen."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Options will be shown in a drop down list. A respondent may select only one option."
      },
      {
        "language": "IT",
        "text": "Le opzioni verranno visualizzate in un menu a tendina. Il partecipante potrà selezionare una sola opzione."
      },
      {
        "language": "CS",
        "text": "Možnosti se zobrazí v rozevíracím seznamu. Respondent může vybrat pouze jednu možnost."
      }
    ]
  },
  {
    "key": "btn_save_criteria",
    "text": "Save Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ المعايير"
      },
      {
        "language": "FR",
        "text": "Sauvegarder les Critčres"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterien speichern"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Save Criteria"
      },
      {
        "language": "IT",
        "text": "Salva i criteri"
      },
      {
        "language": "CS",
        "text": "Uložit kritéria"
      }
    ]
  },
  {
    "key": "txtQAnswer",
    "text": "text here…",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب هنا..."
      },
      {
        "language": "FR",
        "text": "Ecrivez ici…"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Text hier…"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "text here…"
      },
      {
        "language": "IT",
        "text": "testo qui…"
      },
      {
        "language": "CS",
        "text": "text zde …"
      }
    ]
  },
  {
    "key": "txtCriteriaName",
    "text": "Criterion Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المعيار"
      },
      {
        "language": "FR",
        "text": "Nom du Critčre"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriteriumname"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Criterion Name"
      },
      {
        "language": "IT",
        "text": "Nome criterio"
      },
      {
        "language": "CS",
        "text": "Název kritéria"
      }
    ]
  },
  {
    "key": "txtSelectCriteria",
    "text": "Select Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "اختر المعايير"
      },
      {
        "language": "FR",
        "text": "Sélectionner les Critčres"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterien auswählen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Select Criteria"
      },
      {
        "language": "IT",
        "text": "Seleziona i criteri"
      },
      {
        "language": "CS",
        "text": "Vybrat kritéria"
      }
    ]
  },
  {
    "key": "txtAverage",
    "text": "Average",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط"
      },
      {
        "language": "FR",
        "text": "Moyenne"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Durchschnitt"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Average"
      },
      {
        "language": "IT",
        "text": "Media"
      },
      {
        "language": "CS",
        "text": "Průměr"
      }
    ]
  },
  {
    "key": "txtError",
    "text": "Error",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ"
      },
      {
        "language": "FR",
        "text": "Erreur"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Fehler"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Error"
      },
      {
        "language": "IT",
        "text": "Errore"
      },
      {
        "language": "CS",
        "text": "Chyba"
      }
    ]
  },
  {
    "key": "txtErrorText",
    "text": "An error occured. Please, sign in again or contact your administrator.",
    "translations": [
      {
        "language": "AR",
        "text": "حصل خطأ. الرجاء إعادة تسجيل الدخول مرة أخرى أو التواصل مع المسؤول."
      },
      {
        "language": "FR",
        "text": "sign in again or contact your administrator."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ein Fehler ist aufgetreten. Bitte melden Sie sich erneut an oder wenden Sie sich an Ihren Administrator."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "An error occured. Please, sign in again or contact your administrator."
      },
      {
        "language": "IT",
        "text": "Si è verificato un errore. Accedi nuovamente o contatta l'amministratore."
      },
      {
        "language": "CS",
        "text": "Došlo k chybě. Zkuste se prosím přihlásit znovu nebo kontaktujte správce."
      }
    ]
  },
  {
    "key": "txtHopon",
    "text": "Hop on",
    "translations": [
      {
        "language": "AR",
        "text": "هيا بنا"
      },
      {
        "language": "FR",
        "text": "Allons-y "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Steigen Sie ein"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Hop on"
      },
      {
        "language": "IT",
        "text": "Partecipa"
      },
      {
        "language": "CS",
        "text": "Nástup"
      }
    ]
  },
  {
    "key": "txtCreatedBy",
    "text": "Created By:",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانشاء من قبل:"
      },
      {
        "language": "FR",
        "text": "Créé par:"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Created By:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vytvořil:"
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared For",
    "translations": [
      {
        "language": "AR",
        "text": "أُعدَّ لـ"
      },
      {
        "language": "FR",
        "text": "Préparé pour"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorbereitet für"
      },
      {
        "language": "PT",
        "text": "Preparado para"
      },
      {
        "language": "EN",
        "text": "Prepared For"
      },
      {
        "language": "IT",
        "text": "Preparato per"
      },
      {
        "language": "CS",
        "text": "Připravený na:"
      }
    ]
  },
  {
    "key": "txtEmployeeExitReport",
    "text": "Employee Exit Report",
    "translations": [
      {
        "language": "AR",
        "text": "Employee Exit Report"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Exit Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_clear_grouping",
    "text": "Clear Grouping",
    "translations": [
      {
        "language": "AR",
        "text": "إزالة المجموعات"
      },
      {
        "language": "FR",
        "text": "Effacer le Groupement"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gruppierung löschen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Clear Grouping"
      },
      {
        "language": "IT",
        "text": "Cancella il raggruppamento"
      },
      {
        "language": "CS",
        "text": "Vymazat skupinu"
      }
    ]
  },
  {
    "key": "txtGeneratedon",
    "text": "Generated on:",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاؤه في"
      },
      {
        "language": "FR",
        "text": "Généré le:"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Generiert am:"
      },
      {
        "language": "PT",
        "text": "Gerado em"
      },
      {
        "language": "EN",
        "text": "Generated on:"
      },
      {
        "language": "IT",
        "text": "Generato il:"
      },
      {
        "language": "CS",
        "text": "Vytvořeno dne:"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      },
      {
        "language": "FR",
        "text": "Alimenté par:"
      },
      {
        "language": "HI",
        "text": "द्वारा शक्तियुक्त:"
      },
      {
        "language": "TA",
        "text": "Pinatatakbo ng:"
      },
      {
        "language": "UR",
        "text": "قویت یافتہ از:"
      },
      {
        "language": "BN",
        "text": "দ্বারা চালিত:"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Angetrieben von:"
      },
      {
        "language": "PT",
        "text": "Distribuído por:"
      },
      {
        "language": "EN",
        "text": "Powered by:"
      },
      {
        "language": "IT",
        "text": "Offerto da:"
      },
      {
        "language": "CS",
        "text": "Vytvořeno pomocí:"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      },
      {
        "language": "FR",
        "text": "Rapport"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "FR",
        "text": "Pour"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "For"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "FR",
        "text": "Télécharger"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Herunterladen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download"
      },
      {
        "language": "IT",
        "text": "Scarica"
      },
      {
        "language": "CS",
        "text": "Stáhnout"
      }
    ]
  },
  {
    "key": "txtExportReport",
    "text": "Download Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "FR",
        "text": "Rapport de Téléchargement"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stáhnout zprávu"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Cancel"
      },
      {
        "language": "IT",
        "text": "Annulla"
      },
      {
        "language": "CS",
        "text": "Zrušit"
      }
    ]
  },
  {
    "key": "txtApplyChanges",
    "text": "Apply Changes",
    "translations": [
      {
        "language": "AR",
        "text": "طبق التغييرات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Änderungen übernehmen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Apply Changes"
      },
      {
        "language": "IT",
        "text": "Applica le modifiche"
      },
      {
        "language": "CS",
        "text": "Použít změny "
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      },
      {
        "language": "FR",
        "text": "Confidentiel"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Confidential"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      },
      {
        "language": "FR",
        "text": "Taux de Réponse Global"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall Response Rate"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      },
      {
        "language": "FR",
        "text": "Créé  "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Generiert "
      },
      {
        "language": "PT",
        "text": "Gerado "
      },
      {
        "language": "EN",
        "text": "Generated"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vygenerováno"
      }
    ]
  },
  {
    "key": "txtGenerate",
    "text": "Generate",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Generate"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DISPLAYLANGUAGE",
    "text": "DISPLAY LANGUAGE",
    "translations": [
      {
        "language": "AR",
        "text": "لغة العرض"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "ANZEIGESPRACHE"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "DISPLAY LANGUAGE"
      },
      {
        "language": "IT",
        "text": "LINGUA DI VISUALIZZAZIONE"
      },
      {
        "language": "CS",
        "text": "JAZYK ZOBRAZENÍ"
      }
    ]
  },
  {
    "key": "txt_ACTIVEENTITY",
    "text": "ACTIVE ENTITY",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدة الفعالة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "AKTIVE ORGANISATION"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "ACTIVE ENTITY"
      },
      {
        "language": "IT",
        "text": "LIVELLO ORGANIZZATIVO ATTIVO"
      },
      {
        "language": "CS",
        "text": "AKTIVNÍ SUBJEKT"
      }
    ]
  },
  {
    "key": "txtClearAllNotifications",
    "text": "Clear All Notifications",
    "translations": [
      {
        "language": "AR",
        "text": "مسح جميع اللإشعارات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle Benachrichtigungen löschen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Clear All Notifications"
      },
      {
        "language": "IT",
        "text": "Cancella tutte le notifiche"
      },
      {
        "language": "CS",
        "text": "Vymazat všechna oznámení"
      }
    ]
  },
  {
    "key": "Notes",
    "text": "Notes",
    "translations": [
      {
        "language": "AR",
        "text": "الملاحظات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Notes"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDisplayOptions",
    "text": "Display Options",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات العرض"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Anzeigeoptionen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Display Options"
      },
      {
        "language": "IT",
        "text": "Opzioni di visualizzazione"
      },
      {
        "language": "CS",
        "text": "Možnosti zobrazení"
      }
    ]
  },
  {
    "key": "txtPsychometricAssessments",
    "text": "Thomas Hub Insights",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات القياس النفسي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Thomas Hub Insights"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Thomas Hub – Postřehy"
      }
    ]
  },
  {
    "key": "txtEmployeeProducts",
    "text": "EMPLOYEE EXPERIENCE PRODUCTS",
    "translations": [
      {
        "language": "AR",
        "text": "أدوات قياس وتحليل تجربة الموظفين"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "EMPLOYEE EXPERIENCE PRODUCTS"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "PRODUKTY PRO ZAMĚSTNANCE"
      }
    ]
  },
  {
    "key": "txtAnalysis",
    "text": "Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Analysis"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_leavers",
    "text": "Leavers",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفين المغادرين"
      },
      {
        "language": "FR",
        "text": "Sortants"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Leavers"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_dashboard",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Dashboard"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Dashboard"
      },
      {
        "language": "IT",
        "text": "Dashboard"
      },
      {
        "language": "CS",
        "text": "Přehled "
      }
    ]
  },
  {
    "key": "txtEmployeeExitAnalysis",
    "text": "Employee Exit",
    "translations": [
      {
        "language": "AR",
        "text": "خروج الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Exit"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtLogo",
    "text": "Company Logo",
    "translations": [
      {
        "language": "AR",
        "text": "شعار الشركة"
      },
      {
        "language": "FR",
        "text": "Logo de la société"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Company Logo"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtResetPassword",
    "text": "Reset Password",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Réinitialiser le mot de passe"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passwort zurücksetzen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Reset Password"
      },
      {
        "language": "IT",
        "text": "Reimposta la password"
      },
      {
        "language": "CS",
        "text": "Obnovit heslo"
      }
    ]
  },
  {
    "key": "txt_page_settings",
    "text": "Settings",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات"
      },
      {
        "language": "FR",
        "text": "Paramčtres"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Settings"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_notifications",
    "text": "Notifications",
    "translations": [
      {
        "language": "AR",
        "text": "الإشعارات"
      },
      {
        "language": "FR",
        "text": "Notifications"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Benachrichtigungen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Notifications"
      },
      {
        "language": "IT",
        "text": "Notifiche"
      },
      {
        "language": "CS",
        "text": "Notifikace"
      }
    ]
  },
  {
    "key": "txtLoggedinas",
    "text": "Logged in as",
    "translations": [
      {
        "language": "AR",
        "text": "المستخدم الحالي:"
      },
      {
        "language": "FR",
        "text": "Connecté en tant que"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Angemeldet als"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Logged in as"
      },
      {
        "language": "IT",
        "text": "Accesso effettuato come"
      },
      {
        "language": "CS",
        "text": "Přihlášen jako"
      }
    ]
  },
  {
    "key": "txtControlPanel",
    "text": "Control Panel",
    "translations": [
      {
        "language": "AR",
        "text": "لوحة التحكم"
      },
      {
        "language": "FR",
        "text": "Panneau de Commande"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bedienfeld"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Control Panel"
      },
      {
        "language": "IT",
        "text": "Pannello di controllo"
      },
      {
        "language": "CS",
        "text": "Ovládací panel"
      }
    ]
  },
  {
    "key": "txtLogout",
    "text": "Log-out",
    "translations": [
      {
        "language": "AR",
        "text": "تسجيل خروج"
      },
      {
        "language": "FR",
        "text": "Se déconnecter"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Abmelden"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Log-out"
      },
      {
        "language": "IT",
        "text": "Esci"
      },
      {
        "language": "CS",
        "text": "Odhlásit se"
      }
    ]
  },
  {
    "key": "txtSearchEntities",
    "text": "Search entities...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث الوحدات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Organisation suchen..."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Search entities..."
      },
      {
        "language": "IT",
        "text": "Cerca il livello organizzativo..."
      },
      {
        "language": "CS",
        "text": "Vyhledat subjekty..."
      }
    ]
  },
  {
    "key": "txt360FeedbackAssessment",
    "text": "360° Feedback Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم أداء °360 "
      },
      {
        "language": "FR",
        "text": "Évaluation du Commentaire ŕ 360°"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360° Feedback-Beurteilung"
      },
      {
        "language": "PT",
        "text": "Avaliação de Feedback 360°"
      },
      {
        "language": "EN",
        "text": "360° Feedback Assessment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt180FeedbackAssessment",
    "text": "180° Feedback Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم أداء °180 "
      },
      {
        "language": "FR",
        "text": "Évaluation du Commentaire ŕ 180°"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180° Feedback-Beurteilung"
      },
      {
        "language": "PT",
        "text": "Avaliação de Feedback 180°"
      },
      {
        "language": "EN",
        "text": "180° Feedback Assessment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt360FeedbackAssessmentReport",
    "text": "360° Feedback Assessment Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير تقييم أداء °360"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360° Feedback-Bewertungsbericht"
      },
      {
        "language": "PT",
        "text": "Relatório de avaliação de feedback 360°"
      },
      {
        "language": "EN",
        "text": "360° Feedback Assessment Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt180FeedbackAssessmentReport",
    "text": "180° Feedback Assessment Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير تقييم أداء °180"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180° Feedback-Bewertungsbericht"
      },
      {
        "language": "PT",
        "text": "Relatório de avaliação de feedback 180°"
      },
      {
        "language": "EN",
        "text": "180° Feedback Assessment Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtNavigation",
    "text": "Navigation",
    "translations": [
      {
        "language": "AR",
        "text": "التنقل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Navigation"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Navigation"
      },
      {
        "language": "IT",
        "text": "Navigazione"
      },
      {
        "language": "CS",
        "text": "Navigace"
      }
    ]
  },
  {
    "key": "txtPeople",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبين"
      },
      {
        "language": "FR",
        "text": "Répondants"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents"
      },
      {
        "language": "IT",
        "text": "Rispondenti"
      },
      {
        "language": "CS",
        "text": "Respondenti"
      }
    ]
  },
  {
    "key": "txtEmployeeExperience",
    "text": "Employee Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة الموظفين"
      },
      {
        "language": "FR",
        "text": "Expérience des employés"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Experience"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zkušenosti zaměstnanců"
      }
    ]
  },
  {
    "key": "txtDashboard",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Dashboard"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přehledový panel"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "FR",
        "text": "N/A"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "N / A"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "N/A"
      },
      {
        "language": "IT",
        "text": "N/D"
      },
      {
        "language": "CS",
        "text": "Neuvádí se "
      }
    ]
  },
  {
    "key": "btn_save_questionnaire",
    "text": "Save",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ"
      },
      {
        "language": "FR",
        "text": "Sauvegarder"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Save"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Uložit"
      }
    ]
  },
  {
    "key": "txt_respondent_name",
    "text": "Respondent's Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "FR",
        "text": "Nom du Répondant "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondent's Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jméno respondenta"
      }
    ]
  },
  {
    "key": "txt_email_address",
    "text": "Email Address",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الالكتروني"
      },
      {
        "language": "FR",
        "text": "Adresse Email (Adresse électronique)"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Email Address"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "E-mailová adresa"
      }
    ]
  },
  {
    "key": "txtRespondentID",
    "text": "Respondent ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID du Répondant"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondent ID"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "ID respondenta"
      }
    ]
  },
  {
    "key": "txtEditRespondent",
    "text": "Edit Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل بيانات المستجيب"
      },
      {
        "language": "FR",
        "text": "Modifier le Répondant"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Edit Respondent"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Upravit respondenta"
      }
    ]
  },
  {
    "key": "txtEvaluators",
    "text": "Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "المقيمون"
      },
      {
        "language": "FR",
        "text": "Évaluateurs "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Evaluators"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_auto_fill",
    "text": "Type ID or Employee Name to autofill the rest of the fields.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب الرقم الوظيفي أو اسم الموظف لتتم تعبئة باقي الحقول تلقائياً!"
      },
      {
        "language": "FR",
        "text": "Tapez ID ou Nom de l’employé pour remplir automatiquement le reste des champs."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Type ID or Employee Name to autofill the rest of the fields."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAddRespondent_s",
    "text": "Add Respondent(s)",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": "Ajouter Un (des) Répondant(s)"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Respondent(s)"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přidat respondenta (respondenty)"
      }
    ]
  },
  {
    "key": "btn_add_evaluator",
    "text": "Add Evaluator",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": "Ajouter un Évaluateur "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Evaluator hinzufügen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Evaluator"
      },
      {
        "language": "IT",
        "text": "Aggiungi un valutatore"
      },
      {
        "language": "CS",
        "text": "Přidat hodnotitele"
      }
    ]
  },
  {
    "key": "btn_add_candidate",
    "text": "Add Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مرشح"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Candidat"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten hinzufügen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Candidate"
      },
      {
        "language": "IT",
        "text": "Aggiungi un candidato"
      },
      {
        "language": "CS",
        "text": "Přidat uchazeče"
      }
    ]
  },
  {
    "key": "txtAddEvaluator_s",
    "text": "Add Evaluator(s)",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مقيِّم (مقيمين)"
      },
      {
        "language": "FR",
        "text": "Ajouter Un (des) Évaluateur(s) "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewerter hinzufügen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Add Evaluator(s)"
      },
      {
        "language": "IT",
        "text": "Aggiungi uno o più valutatori"
      },
      {
        "language": "CS",
        "text": "Přidat hodnotitele"
      }
    ]
  },
  {
    "key": "txtCandidates",
    "text": "Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحون"
      },
      {
        "language": "FR",
        "text": "Candidats"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Candidates"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "Info",
    "text": "Info",
    "translations": [
      {
        "language": "AR",
        "text": "معلومة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Info"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtCandidateName",
    "text": "Candidate's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المرشح"
      },
      {
        "language": "FR",
        "text": "Nom du Candidat"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Candidate's Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jméno respondenta"
      }
    ]
  },
  {
    "key": "txtRelationshipType",
    "text": "Relationship Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع العلاقة"
      },
      {
        "language": "FR",
        "text": "Type de Relation"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Beziehungstyp"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Relationship Type"
      },
      {
        "language": "IT",
        "text": "Tipo di relazione"
      },
      {
        "language": "CS",
        "text": "Typ vztahu/vazby"
      }
    ]
  },
  {
    "key": "txtChooseType",
    "text": "Relationship Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع العلاقة"
      },
      {
        "language": "FR",
        "text": "Type de Relation"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Beziehungstyp"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Relationship Type"
      },
      {
        "language": "IT",
        "text": "Tipo di relazione"
      },
      {
        "language": "CS",
        "text": "Typ vztahu"
      }
    ]
  },
  {
    "key": "txt_respondents_pool",
    "text": "Respondent Pool",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبون"
      },
      {
        "language": "FR",
        "text": "Réserve des Répondants"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Teilnehmerpool"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondent Pool"
      },
      {
        "language": "IT",
        "text": "Pool di rispondenti"
      },
      {
        "language": "CS",
        "text": "Skupina respondentů"
      }
    ]
  },
  {
    "key": "txt_new_respondent",
    "text": "New Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": "Nouveau Répondant"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neuer Befragter"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Respondent"
      },
      {
        "language": "IT",
        "text": "Nuovo rispondente"
      },
      {
        "language": "CS",
        "text": "Nový respondent"
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": "Répondants"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Respondents"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_validation_min",
    "text": "minimum characters not met.",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم مطابقة الحد الأدنى لعدد الحروف."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "minimum characters not met."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "není splněn minimální počet znaků."
      }
    ]
  },
  {
    "key": "txt_validation_max",
    "text": "Exceeded maximum characters",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تجاوزت الحد الأقصى لعدد الحروف"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Exceeded maximum characters"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Překročen maximální počet znaků"
      }
    ]
  },
  {
    "key": "txtDescription",
    "text": "text here…",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب هنا..."
      },
      {
        "language": "FR",
        "text": "Ecrivez ici…"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Text hier…"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "text here…"
      },
      {
        "language": "IT",
        "text": "testo qui…"
      },
      {
        "language": "CS",
        "text": "zde vložte text …"
      }
    ]
  },
  {
    "key": "txt_Employee_Engagement_Survey",
    "text": "Employee Engagement Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Enquęte sur l’engagement des employés"
      },
      {
        "language": "BN",
        "text": "কর্মচারী নিয়োগ সমীক্ষা"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Engagement Survey"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průzkum zapojení zaměstnanců"
      }
    ]
  },
  {
    "key": "txt_unitsAdded",
    "text": "Unit(s) Added",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات المضافة"
      },
      {
        "language": "FR",
        "text": "Unités Ajoutées"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Einheit(en) hinzugefügt"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Unit(s) Added"
      },
      {
        "language": "IT",
        "text": "Unità aggiunta/e"
      },
      {
        "language": "CS",
        "text": "Přidané jednotky"
      }
    ]
  },
  {
    "key": "txt_totalUnits",
    "text": "New Total Balance",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي الرصيد الجديد"
      },
      {
        "language": "FR",
        "text": "Nouveau Solde Total"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "New Total Balance"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nový celkový zůstatek"
      }
    ]
  },
  {
    "key": "txt_units",
    "text": "Units",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unités"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Units"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_unit",
    "text": "Unit",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "BN",
        "text": "ইউনিট"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Unit"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtTemplateEmail",
    "text": "This template is optimized for email clients \"Gmail, Outook, ...etc\" please modify with care. If you wish to revert to the default template click on the \"Default Template\" button.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحسين هذا النموذج لمستخدمي البريد الالكتروني الخاص بـ \"Gmail, Outlook,…etc\" الرجاء التعديل بحذر. إذا كنت ترغب بالتحويل للنموذج الأساسي اضغط على زر \"النموذج الأساسي\"."
      },
      {
        "language": "FR",
        "text": "Ce modèle est optimisé pour les clients de messagerie \"Gmail, Outlook, ...etc.\" veuillez le modifier avec soin. Si vous souhaitez revenir au modèle de base, cliquez sur le bouton \"Modèle de base\"."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Diese Vorlage ist für E-Mail-Clients wie Gmail, Outlook usw. optimiert. Bitte nehmen Sie Änderungen mit Bedacht vor. Wenn Sie zur Standardvorlage zurückkehren möchten, klicken Sie auf die Schaltfläche „Standardvorlage“."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "This template is optimized for email clients \"Gmail, Outook, ...etc\" please modify with care. If you wish to revert to the default template click on the \"Default Template\" button."
      },
      {
        "language": "IT",
        "text": "Questo template è ottimizzato per i client di posta elettronica come \"Gmail, Outlook, ...ecc.\". Modificalo con attenzione. Se desideri ripristinare il template predefinito, clicca sul pulsante \"Template predefinito\"."
      },
      {
        "language": "CS",
        "text": "Tato šablona je optimalizována pro e-mailové klienty jako „Gmail, Outlook atd.“. Upravujte ji prosím s opatrností. Pokud se chcete vrátit k výchozí šabloně, klikněte na tlačítko „Výchozí šablona“."
      }
    ]
  },
  {
    "key": "txtDefaultTemplate",
    "text": "Default Template",
    "translations": [
      {
        "language": "AR",
        "text": "النموذج الأساسي"
      },
      {
        "language": "FR",
        "text": "Modčle de base"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Standardvorlage"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Default Template"
      },
      {
        "language": "IT",
        "text": "Template predefinito"
      },
      {
        "language": "CS",
        "text": "Výchozí šablona"
      }
    ]
  },
  {
    "key": "txt_send_to",
    "text": "Send To",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال إلى"
      },
      {
        "language": "FR",
        "text": "Envoyer ŕ"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Senden an"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Send To"
      },
      {
        "language": "IT",
        "text": "Invia a"
      },
      {
        "language": "CS",
        "text": "Odeslat na"
      }
    ]
  },
  {
    "key": "txt_subject_line",
    "text": "Subject Line",
    "translations": [
      {
        "language": "AR",
        "text": "خانة العنوان"
      },
      {
        "language": "FR",
        "text": "Boîte d’adresse"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Betreffzeile"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Subject Line"
      },
      {
        "language": "IT",
        "text": "Oggetto"
      },
      {
        "language": "CS",
        "text": "Předmět"
      }
    ]
  },
  {
    "key": "txtDownloadExcel",
    "text": "Download Excel",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل ملف Excel"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "txtHerunterladenExcel"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download Excel"
      },
      {
        "language": "IT",
        "text": "txtScaricaExcel"
      },
      {
        "language": "CS",
        "text": "Stáhnout soubor Excel"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      },
      {
        "language": "FR",
        "text": "Table des matičres"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Inhaltsverzeichnis"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Table of Contents"
      },
      {
        "language": "IT",
        "text": "Indice"
      },
      {
        "language": "CS",
        "text": "Obsah"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      },
      {
        "language": "FR",
        "text": "Tous les droits sont réservés"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle Rechte vorbehalten"
      },
      {
        "language": "PT",
        "text": "Todos os direitos reservados"
      },
      {
        "language": "EN",
        "text": "All Rights Reserved"
      },
      {
        "language": "IT",
        "text": "Tutti i diritti riservati"
      },
      {
        "language": "CS",
        "text": "Všechna práva vyhrazena"
      }
    ]
  },
  {
    "key": "btn_leaver_list_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Cancel"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zrušit"
      }
    ]
  },
  {
    "key": "txtSurveys",
    "text": "Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "استبيانات"
      },
      {
        "language": "FR",
        "text": "Enquętes"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Surveys"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAssessment",
    "text": "Assessments",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Assessments"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtComparison",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vergleich"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comparison"
      },
      {
        "language": "IT",
        "text": "Confronto"
      },
      {
        "language": "CS",
        "text": "Porovnání"
      }
    ]
  },
  {
    "key": "txtSurveyClosed",
    "text": "The survey has been closed, keep an eye for the next one.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تم إنهاء هذا الاستبيان"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "The survey has been closed, keep an eye for the next one."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průzkum byl ukončen, sledujte, kdy se objeví další."
      }
    ]
  },
  {
    "key": "txtSurveyClosedTitle",
    "text": "Survey Closed",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان منتهي"
      },
      {
        "language": "FR",
        "text": "Enquęte s'est achevée "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Closed"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průzkum ukončen"
      }
    ]
  },
  {
    "key": "txtThankYou",
    "text": "Thank you!",
    "translations": [
      {
        "language": "AR",
        "text": "شكراً لك!"
      },
      {
        "language": "FR",
        "text": "Merci!"
      },
      {
        "language": "HI",
        "text": "धन्यवाद"
      },
      {
        "language": "TA",
        "text": "Salamat"
      },
      {
        "language": "UR",
        "text": "آپ کا شکریہ"
      },
      {
        "language": "BN",
        "text": "ধন্যবাদ"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Thank you!"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Děkujeme!"
      }
    ]
  },
  {
    "key": "txtSurveyCompleteTitle",
    "text": "Survey Completed",
    "translations": [
      {
        "language": "AR",
        "text": "تم إكمال الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte Terminé"
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण पूरा हुआ"
      },
      {
        "language": "TA",
        "text": "Nakumpleto ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے مکمل ہوا"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা সম্পন্ন হয়েছে"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Completed"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurvey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtanswered",
    "text": "answered",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإجابة عليه"
      },
      {
        "language": "FR",
        "text": "Répondu"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "answered"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "odpověděli"
      }
    ]
  },
  {
    "key": "txt_assessment_preview_survey",
    "text": "360° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "360° Assessment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_assessment180_preview_survey",
    "text": "180° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "180° Assessment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_question",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "FR",
        "text": "Question"
      },
      {
        "language": "BN",
        "text": "প্রশ্ন"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Statement"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtEvaluatorTypeRequired",
    "text": "Evaluator type must be included",
    "translations": [
      {
        "language": "AR",
        "text": "يجب ذكر نوع المقيم"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Der Evaluatortyp muss angegeben werden"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Evaluator type must be included"
      },
      {
        "language": "IT",
        "text": "Il tipo di valutatore deve essere incluso"
      },
      {
        "language": "CS",
        "text": "Je nutné uvést typ hodnotitele"
      }
    ]
  },
  {
    "key": "txtSection",
    "text": "Section",
    "translations": [
      {
        "language": "AR",
        "text": "قسم"
      },
      {
        "language": "FR",
        "text": "Section"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Section"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "sekce"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "FR",
        "text": "Rechercher"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Suchen"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Search"
      },
      {
        "language": "IT",
        "text": "Cerca"
      },
      {
        "language": "CS",
        "text": "Vyhledat"
      }
    ]
  },
  {
    "key": "txtclear",
    "text": "Clear",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      },
      {
        "language": "HI",
        "text": "साफ़ करे"
      },
      {
        "language": "TA",
        "text": "Malinaw"
      },
      {
        "language": "UR",
        "text": "صاف کریں"
      },
      {
        "language": "BN",
        "text": "ক্লিয়ার"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Clear"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "vymazat"
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID de l'Employé"
      },
      {
        "language": "HI",
        "text": "ID"
      },
      {
        "language": "TA",
        "text": "ID"
      },
      {
        "language": "UR",
        "text": "ID"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Mitarbeiter-ID"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee ID"
      },
      {
        "language": "IT",
        "text": "ID dipendente"
      },
      {
        "language": "CS",
        "text": "Osobní číslo zaměstnance"
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please, fill all required fields!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة!"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bitte füllen Sie alle erforderlichen Felder aus!"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Please, fill all required fields!"
      },
      {
        "language": "IT",
        "text": "Compila tutti i campi obbligatori!"
      },
      {
        "language": "CS",
        "text": "Vyplňte prosím všechna povinná pole!"
      }
    ]
  },
  {
    "key": "txt_wrong_text_count",
    "text": "Exceeded text limit.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز عدد الأحرف المسموح به"
      },
      {
        "language": "FR",
        "text": "Limite de texte dépassée."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Textlimit überschritten."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Exceeded text limit."
      },
      {
        "language": "IT",
        "text": "Limite di testo superato."
      },
      {
        "language": "CS",
        "text": "Překročen limit počtu znaků."
      }
    ]
  },
  {
    "key": "txtBeforeStarting",
    "text": "Before you begin with the survey, kindly fill the below:",
    "translations": [
      {
        "language": "AR",
        "text": "قبل البدء بالاستبيان، يرجى تعبئة المعلومات أدناه:"
      },
      {
        "language": "FR",
        "text": "Kindly fill in the info below:"
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण शुरू करने से पहले, कृपया नीचे दी गई जानकारी भरें:"
      },
      {
        "language": "TA",
        "text": "Bago ka magsimula sa survey, mangyaring punan ang ibaba:"
      },
      {
        "language": "UR",
        "text": "سروے شروع کرنے سے پہلے، برائے مہربانی مندرجہ ذیل کو پر کریں:"
      },
      {
        "language": "BN",
        "text": "আপনি সমীক্ষা শুরু করার আগে, অনুগ্রহ করে নিম্নপ্রদত্তটি পূরণ করুন:"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Before you begin with the survey, kindly fill the below:"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Než začnete s dotazníkem, vyplňte prosím následující údaje:"
      }
    ]
  },
  {
    "key": "txt_start_survey",
    "text": "Start Survey",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ الاستبيان"
      },
      {
        "language": "FR",
        "text": "Commencer l'Évaluation "
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण शुरू करें"
      },
      {
        "language": "TA",
        "text": "Simulan ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے شروع کریں"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা আরম্ভ করুন"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Start Survey"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_start_assessment",
    "text": "Start Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ التقييم"
      },
      {
        "language": "FR",
        "text": "Commencer l'Évaluation "
      },
      {
        "language": "HI",
        "text": "सर्वेक्षण शुरू करें"
      },
      {
        "language": "TA",
        "text": "Simulan ang Survey"
      },
      {
        "language": "UR",
        "text": "سروے شروع کریں"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Start Assessment"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_valid_vmail",
    "text": "Please provide a valid email.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال بريد إلكتروني صحيح"
      },
      {
        "language": "FR",
        "text": "S'il vous plaît fournissez un email (courrier électronique) valide."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bitte geben Sie eine gültige E-Mail-Adresse ein."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Please. provide a valid email."
      },
      {
        "language": "IT",
        "text": "Fornisci un'email valida."
      },
      {
        "language": "CS",
        "text": "Zadejte prosím platnou e-mailovou adresu."
      }
    ]
  },
  {
    "key": "txt_evaluator_name",
    "text": "Evaluator's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المقيم"
      },
      {
        "language": "FR",
        "text": "Nom de l'Évaluateur "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Evaluator's Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jméno hodnotitele"
      }
    ]
  },
  {
    "key": "txt_required_field",
    "text": "This field is required",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الحقل إجباري"
      },
      {
        "language": "FR",
        "text": "Ce champ est requis"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Dieses Feld ist ein Pflichtfeld"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "This field is required"
      },
      {
        "language": "IT",
        "text": "Questo campo è obbligatorio"
      },
      {
        "language": "CS",
        "text": "Toto pole je povinné"
      }
    ]
  },
  {
    "key": "txtSpecifyHere",
    "text": "Specify here...",
    "translations": [
      {
        "language": "AR",
        "text": "وضح هنا..."
      },
      {
        "language": "FR",
        "text": "Précisez ici ..."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Specify here..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte zde..."
      }
    ]
  },
  {
    "key": "txt_happiness_preview_survey",
    "text": "Happiness Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان سعادة الموظفين"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Happiness Survey Preview"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtMinimumTwoOptions",
    "text": "minimum two options are needed.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار خيارين على الأقل."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Es sind mindestens zwei Optionen erforderlich."
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "minimum two options are needed."
      },
      {
        "language": "IT",
        "text": "Sono necessarie almeno due opzioni."
      },
      {
        "language": "CS",
        "text": "Jsou zapotřebí minimálně dvě možnosti."
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Survey Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الاستبيان"
      },
      {
        "language": "FR",
        "text": "Nom de Enquęte "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Survey Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_questionnaire180_name",
    "text": "Assessment Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم التقييم"
      },
      {
        "language": "FR",
        "text": "Nom de Enquęte "
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Assessment Name"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtHappinessReport",
    "text": "Employee Happiness Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير سعادة الموظف"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Happiness Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtEngagementReport",
    "text": "Employee Engagement Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Rapport sur l’Engagement de l'Employé"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Employee Engagement Report"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_engagement_preview_survey",
    "text": "Engagement Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان الاندماج الوظيفي"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Engagement Survey Preview"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtMostLiked",
    "text": "Most Liked...",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر تفضيلاً"
      },
      {
        "language": "FR",
        "text": "Le Plus Préféré..."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Most Liked..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nejoblíbenější..."
      }
    ]
  },
  {
    "key": "txtLeastLiked",
    "text": "Least Liked...",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل تفضيلاً"
      },
      {
        "language": "FR",
        "text": "Le Moins Préféré..."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Least Liked..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nejméně oblíbené..."
      }
    ]
  },
  {
    "key": "txtTypeComment",
    "text": "Type your comment here ...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب تعليقك هنا …"
      },
      {
        "language": "FR",
        "text": "Ecrivez ici…"
      },
      {
        "language": "HI",
        "text": "अपनी टिप्पणी यहां टाइप करें…"
      },
      {
        "language": "TA",
        "text": "I-type ang iyong komento dito…"
      },
      {
        "language": "UR",
        "text": "اپنا تبصرہ یہاں ٹائپ کریں..."
      },
      {
        "language": "BN",
        "text": "আপনার মন্তব্য এখানে লিখুন..."
      },
      {
        "language": "ES",
        "text": "Escribe tu comentario aquí ..."
      },
      {
        "language": "SI",
        "text": "ඔබේ අදහස මෙහි ටයිප් කරන්න..."
      },
      {
        "language": "NE",
        "text": "यहाँ आफ्नो टिप्पणी टाइप गर्नुहोस् …"
      },
      {
        "language": "ML",
        "text": "നിങ്ങളുടെ അഭിപ്രായം ഇവിടെ ടൈപ്പ് ചെയ്യുക..."
      },
      {
        "language": "ID",
        "text": "Tulis komentarmu di sini …"
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Type your comment here ..."
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Napište sem svůj komentář"
      }
    ]
  },
  {
    "key": "txtType",
    "text": "Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع"
      },
      {
        "language": "FR",
        "text": "Type"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Type"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte"
      }
    ]
  },
  {
    "key": "txt_custom_input_translation",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "ترجمة "
      },
      {
        "language": "FR",
        "text": "Traduction"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Übersetzung"
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Translation"
      },
      {
        "language": "IT",
        "text": "Traduzione"
      },
      {
        "language": "CS",
        "text": "Překlad"
      }
    ]
  },
  {
    "key": "txt_INPROGRESS",
    "text": "In-progress",
    "translations": [
      {
        "language": "EN",
        "text": "In-progress"
      },
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_COMPLETED",
    "text": "Completed",
    "translations": [
      {
        "language": "EN",
        "text": "Completed"
      },
      {
        "language": "AR",
        "text": "منجز"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_POSTED",
    "text": "Scheduled",
    "translations": [
      {
        "language": "EN",
        "text": "Scheduled"
      },
      {
        "language": "AR",
        "text": "مُجَدوَل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EXPIRED",
    "text": "Expired",
    "translations": [
      {
        "language": "EN",
        "text": "Expired"
      },
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "ES",
        "text": "Vencido"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ALL",
    "text": "All",
    "translations": [
      {
        "language": "EN",
        "text": "All"
      },
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_PENDING",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تعبئة "
      },
      {
        "language": "FR",
        "text": "En attente"
      },
      {
        "language": "ES",
        "text": "No empezado"
      },
      {
        "language": "SI",
        "text": ""
      },
      {
        "language": "NE",
        "text": ""
      },
      {
        "language": "ML",
        "text": ""
      },
      {
        "language": "ID",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Not Started"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txtComparison_ai-readiness",
    "text": "Ready to uncover your survey history's top AI readiness scores and compare them across years and companies (if any)? Discover the answer now!",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج جاهزية الذكاء الاصطناعي ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن!"
      },
      {
        "language": "EN",
        "text": "Ready to uncover your survey history's top AI readiness scores and compare them across years and companies (if any)? Discover the answer now!"
      }
    ]
  }
]
